(function () {
  Window.data = Window.data || {};
  Window.data.csv = Window.data.csv || {};

  Window.data.csv.data = [
    {
      id_registro: 45762,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 37835,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37838,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 38259,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38590,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 39472,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 40023,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 45485,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 31980,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32214,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32279,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32474,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32476,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32484,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32678,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32681,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32682,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32968,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 32972,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33034,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33037,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33125,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33172,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33261,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33331,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33340,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33373,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 33486,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33489,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33497,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33524,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33534,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33546,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33675,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33677,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33685,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33687,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33700,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33746,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33753,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33773,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33799,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33802,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33987,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34210,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34305,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34416,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34418,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34502,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34524,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34529,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34535,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34566,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34779,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34986,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34991,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34994,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35357,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 35375,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35377,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35561,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35562,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35754,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 35826,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36061,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36246,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 37597,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 38667,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 31680,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31932,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 31962,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32386,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32407,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32651,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32677,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32762,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32787,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32905,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33092,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33108,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33235,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33336,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33949,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34131,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34178,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34179,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34188,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 34260,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34894,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34995,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 36680,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36690,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36973,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37084,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37086,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37382,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37385,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37387,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37439,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37840,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 42290,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-6",
    },
    {
      id_registro: 32358,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 33462,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33525,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33749,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34071,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 34175,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34176,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34177,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34385,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 34387,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34388,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 34391,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34436,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34451,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34697,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34996,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35368,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35370,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35372,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35742,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35748,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35982,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36165,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36467,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36474,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36477,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36754,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 36927,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36962,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37072,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37297,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37405,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37418,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37428,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37529,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37536,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37541,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37545,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37546,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 37549,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37555,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37768,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37932,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38013,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38183,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38206,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38208,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38732,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38740,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38850,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38926,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 39065,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 39231,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39342,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39343,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39344,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39601,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39605,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39708,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39863,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 39884,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40174,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40230,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40231,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40513,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 40797,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 40905,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 41065,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 41418,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41420,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41795,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 33948,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34257,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34445,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34448,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34450,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34586,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34797,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35903,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36441,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36505,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 37680,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 33617,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 34594,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 38649,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 39006,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39010,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39182,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39186,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39455,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39458,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 39782,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39981,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 41732,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 31302,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 36883,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37342,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37478,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37641,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37763,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37865,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37895,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 37984,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37985,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38081,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38129,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38133,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38146,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-10",
    },
    {
      id_registro: 38368,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38391,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38393,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38521,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38654,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38675,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38757,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38867,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38904,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39017,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39019,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39041,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39045,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39047,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39050,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39249,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39314,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39315,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39319,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39321,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39473,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39532,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39557,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39644,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39703,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39808,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39812,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 39891,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39895,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39897,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39903,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39911,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 40043,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40044,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40045,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40046,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40049,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40052,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40054,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40055,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40060,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40142,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40143,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40182,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40194,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40251,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40393,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40680,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40681,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40682,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40683,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40729,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40731,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40796,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40798,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40918,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40921,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 41018,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 41021,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41023,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41024,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41036,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41104,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41231,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-15",
    },
    {
      id_registro: 41232,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41233,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41234,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41297,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-15",
    },
    {
      id_registro: 41303,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-15",
    },
    {
      id_registro: 41399,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 41401,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41402,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41449,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 41674,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 41675,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 41832,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41834,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41840,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42488,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42489,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42490,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42498,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42500,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42664,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42709,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 43026,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-21",
    },
    {
      id_registro: 43227,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-27",
    },
    {
      id_registro: 43486,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-30",
    },
    {
      id_registro: 44180,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44791,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44982,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-9",
    },
    {
      id_registro: 38865,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38797,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38231,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-10",
    },
    {
      id_registro: 38236,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38795,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 41109,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41110,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41111,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 38652,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 37309,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37314,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 38082,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 39032,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39099,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39133,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39135,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39272,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39445,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 39471,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39723,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39740,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39749,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 40042,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40280,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40352,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40353,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40354,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40355,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40356,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 40357,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40358,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40359,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40484,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 40487,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 40488,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40490,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40492,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40541,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 40876,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-05",
    },
    {
      id_registro: 40956,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 41108,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41375,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 42199,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-3",
    },
    {
      id_registro: 38400,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 41905,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-26",
    },
    {
      id_registro: 37585,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 45053,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-9",
    },
    {
      id_registro: 42620,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 35245,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 39559,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 40287,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40603,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 41387,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41575,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-22",
    },
    {
      id_registro: 41678,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 41681,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 41682,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 41734,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 37562,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 38053,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38197,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-10",
    },
    {
      id_registro: 38787,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38796,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 39053,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39069,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39698,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39967,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 39969,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39971,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 38320,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38321,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 39285,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 33634,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 34159,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34163,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34795,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35170,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 36073,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 37025,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37079,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37085,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37123,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37193,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37278,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37371,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37483,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37487,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37550,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37988,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37991,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37992,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37993,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37994,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37996,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37999,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38020,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38293,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38300,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38306,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38311,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38325,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38729,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38736,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38739,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 38742,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38750,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 39159,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39161,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39347,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39350,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39353,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39518,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39519,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39634,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39636,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39957,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40167,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40170,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40236,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40238,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 41137,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-12",
    },
    {
      id_registro: 41220,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-12",
    },
    {
      id_registro: 31885,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31887,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 32056,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32894,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32924,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33147,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 34052,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34169,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34360,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 34440,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34447,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 36023,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36338,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 37043,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37203,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37204,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37224,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37489,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37560,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37735,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 38012,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38718,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38720,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38741,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 39015,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39363,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39365,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39517,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39813,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 41823,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 32357,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32731,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32356,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32619,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32722,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 33828,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 35256,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35436,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 37206,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37213,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37343,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 39673,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39882,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-10",
    },
    {
      id_registro: 37892,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37911,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 40509,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 33450,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 34454,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34887,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35657,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35740,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 36249,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 37575,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 31740,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 31805,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 32120,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32121,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32122,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32123,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32124,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32125,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32126,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32217,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32220,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32223,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32230,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32231,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32261,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32262,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32441,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32552,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32555,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32558,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32655,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 33243,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33245,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 33416,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33529,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33539,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33541,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33554,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33793,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 34398,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34824,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34827,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34828,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34902,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34904,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34907,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34908,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34910,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34913,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34914,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35097,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35555,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35655,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35656,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 36140,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36141,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36310,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36312,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36377,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36378,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36379,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36380,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36381,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36774,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36893,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 38134,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38135,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38136,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38137,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38139,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38141,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38143,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38144,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38220,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38221,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38222,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38224,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38449,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38450,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38451,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38452,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38453,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38454,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38455,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38456,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38656,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38657,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38658,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38659,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38751,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38812,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38893,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38894,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38895,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38896,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38943,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38944,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38945,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39033,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39034,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39063,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 40772,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-05",
    },
    {
      id_registro: 40800,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40801,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40802,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40803,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 40863,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-05",
    },
    {
      id_registro: 41132,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 41981,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 44729,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44762,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44765,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 45808,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 32730,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 33306,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 34032,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34058,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34410,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35060,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35182,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35185,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35188,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35192,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35536,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35873,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 35908,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 35950,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36041,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36042,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36043,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36044,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36045,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36235,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36311,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36445,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36448,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36449,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36564,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36566,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36568,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36572,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36573,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36575,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36576,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36579,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36580,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36581,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36583,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36585,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36587,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36589,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36591,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 36593,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36594,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36595,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36630,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 36892,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37479,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37588,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37770,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37800,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37801,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 38465,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38672,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 38702,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 39608,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39706,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39707,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 40077,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40257,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 41893,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-26",
    },
    {
      id_registro: 43381,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 44055,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 36046,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36708,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 33456,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 34756,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 33100,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 34128,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 37051,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37979,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 39009,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 32424,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 34657,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34713,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 32097,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32118,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 33869,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 38088,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38322,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38324,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38327,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38328,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38329,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38330,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38331,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38432,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38871,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 39024,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39025,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39914,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39916,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40255,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40453,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40454,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40458,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40465,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40469,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40471,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 31200,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-15",
    },
    {
      id_registro: 33863,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33864,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 31907,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 31910,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 31915,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 35244,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 37713,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37714,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37715,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37716,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37717,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 37945,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37977,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 38073,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38074,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 38075,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38415,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38419,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38699,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38704,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38706,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38880,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38882,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38884,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 39416,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 40460,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 41348,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 41350,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 31012,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31337,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31460,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31477,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31653,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-24",
    },
    {
      id_registro: 31677,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31678,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-25",
    },
    {
      id_registro: 31679,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31734,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31904,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 32103,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32251,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32846,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32987,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 31921,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 36629,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 40186,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 37350,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37351,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37352,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 38628,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 39201,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39202,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39290,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39291,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39643,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 40200,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40188,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40191,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40952,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 40953,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 37107,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 36574,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36970,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36972,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37108,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37265,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37353,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37444,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37509,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37649,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37650,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37651,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37653,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37654,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37958,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 37960,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38026,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38071,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38076,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38290,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38443,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38621,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38624,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38627,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38846,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38976,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39200,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39203,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39271,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39860,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 39938,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40129,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40574,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 40575,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 40695,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40774,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 41218,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 36924,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37112,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37113,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37114,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37354,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37868,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 38890,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 37188,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37191,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 38788,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38889,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 37271,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37656,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 32763,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32766,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 33959,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33960,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 33961,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33962,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34035,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 34037,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 34464,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34794,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 34801,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 34973,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35254,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35258,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35534,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35676,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35804,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36422,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 36426,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36539,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 36895,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36898,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36899,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37008,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37111,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37266,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37268,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37450,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37481,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37484,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 37566,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37567,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37648,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37785,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37786,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37790,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37889,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37965,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 37970,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 37974,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 37976,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38036,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38054,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38067,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38131,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38164,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38248,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38299,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38304,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38384,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38385,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38386,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38485,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38499,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38507,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38511,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38513,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38570,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38571,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38572,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38580,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38633,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38638,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38662,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38697,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38719,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38748,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38749,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38818,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38820,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38891,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38962,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38963,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38964,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39141,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39197,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39199,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39261,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39265,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39270,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39373,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39374,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39378,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39434,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39435,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39485,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39575,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39578,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39579,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39581,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39666,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39679,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39681,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39773,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 39807,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40004,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40011,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40097,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40140,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40141,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 32799,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 35107,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35697,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36450,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36560,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 37159,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37162,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37394,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37400,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37409,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37485,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37488,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37491,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37493,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37494,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37496,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37503,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37683,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37731,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37884,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37885,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37886,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37925,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38056,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38202,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38204,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38207,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38478,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38610,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38611,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38612,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38616,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38671,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38759,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 39100,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39335,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 39660,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39871,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39876,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39932,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 41114,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 41632,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41695,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 42261,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-7",
    },
    {
      id_registro: 46193,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-04",
    },
    {
      id_registro: 39722,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 39904,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-10-20",
    },
    {
      id_registro: 45403,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45405,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45519,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45605,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45606,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45607,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45608,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45610,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45697,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45698,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45700,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45983,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 45987,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45990,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 45992,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 45994,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 45996,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45999,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 40394,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-09-05",
    },
    {
      id_registro: 44694,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44709,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44821,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 45431,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 45438,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 44776,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 45960,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 44766,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 40249,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 39920,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 43580,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 46182,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 36811,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-06-14",
    },
    {
      id_registro: 37878,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 32715,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 32719,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 32729,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33583,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-04-27",
    },
    {
      id_registro: 33586,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-04-27",
    },
    {
      id_registro: 34403,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-05-10",
    },
    {
      id_registro: 34404,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-05-10",
    },
    {
      id_registro: 37778,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-06-28",
    },
    {
      id_registro: 35635,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 38601,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38849,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 36337,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 36471,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 36696,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 41697,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41700,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41703,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41705,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41707,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41975,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41978,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41980,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41985,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41989,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41991,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41992,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41996,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41997,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 42001,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 42002,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 42005,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 42017,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 33603,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 36711,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36812,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-06-14",
    },
    {
      id_registro: 36874,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 37727,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-06-28",
    },
    {
      id_registro: 39576,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-02",
    },
    {
      id_registro: 45039,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 45309,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 34417,
      entidad_nombre_res: "GUANAJUATO",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 37579,
      entidad_nombre_res: "GUANAJUATO",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 38203,
      entidad_nombre_res: "GUANAJUATO",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 34121,
      entidad_nombre_res: "GUANAJUATO",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 44157,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-16",
    },
    {
      id_registro: 43797,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 43843,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 43845,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44348,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44351,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44740,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44783,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44784,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44785,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44050,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44051,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44053,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44054,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44056,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44058,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44373,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44375,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44376,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44377,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44470,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-24",
    },
    {
      id_registro: 44852,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44999,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45304,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 42686,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42254,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 39853,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 39854,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 39913,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40348,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 43253,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43139,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43141,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 39275,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 39276,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39277,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39278,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 39279,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39280,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-14",
    },
    {
      id_registro: 39281,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39282,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39283,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39483,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39733,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 39734,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 39792,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 39975,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-20",
    },
    {
      id_registro: 41895,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 41956,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 42601,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42603,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43250,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 44159,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44162,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44718,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44719,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44721,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 46186,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 35128,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 39284,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39479,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39482,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 40130,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-14",
    },
    {
      id_registro: 40131,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40299,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40361,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40373,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40375,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40376,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40416,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 41291,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41292,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41559,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41563,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41894,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 42324,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 42326,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 42648,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42650,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43344,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 43516,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 43517,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 43758,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 43761,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44659,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44662,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-29",
    },
    {
      id_registro: 44712,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44927,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 44928,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 44986,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45341,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45342,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45343,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45344,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45345,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45346,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45347,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45348,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45349,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45350,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45351,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45352,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45353,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45354,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45355,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45356,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45778,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 40877,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 40878,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-21",
    },
    {
      id_registro: 34465,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 34466,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 34918,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 38959,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 38960,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39568,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39569,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39570,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39571,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39572,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 40099,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-20",
    },
    {
      id_registro: 40161,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40163,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40305,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40313,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 41183,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41200,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41440,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41467,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41469,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41471,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 42216,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 42645,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42703,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42704,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42705,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43029,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43152,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43155,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43754,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44297,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44461,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44521,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44926,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 44956,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45367,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45369,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45714,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 34640,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 42537,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42604,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42654,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42827,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42830,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43147,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43255,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 44068,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44226,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 42697,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 41957,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 44245,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 39567,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 43043,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 42607,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 41336,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 43469,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 43620,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 43862,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 43885,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44229,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44236,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44257,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44315,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44501,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44504,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44595,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44746,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44921,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45060,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45062,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45066,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45978,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 46071,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 40812,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 41792,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 42535,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 42979,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43242,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43243,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43246,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43520,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 43975,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 43978,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44067,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44084,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44085,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44247,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44303,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44448,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-23",
    },
    {
      id_registro: 44481,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44482,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 44539,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44542,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44702,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44704,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44706,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-29",
    },
    {
      id_registro: 44715,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-29",
    },
    {
      id_registro: 44814,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44832,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44882,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44958,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 44964,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 44971,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 45076,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45077,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45078,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45079,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45088,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45207,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45209,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45214,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45408,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45409,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45639,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45862,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45863,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45946,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46098,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 44594,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 45285,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45407,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 40809,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 43765,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44420,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-25",
    },
    {
      id_registro: 45373,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45448,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45449,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45809,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 42096,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 42335,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 43525,
      entidad_nombre_res: "HIDALGO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 41507,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41677,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41679,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41683,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41760,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41835,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41836,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41838,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41960,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42573,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42903,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-17",
    },
    {
      id_registro: 42904,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-17",
    },
    {
      id_registro: 42905,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-17",
    },
    {
      id_registro: 42958,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42959,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 43119,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 43120,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 43190,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43980,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 45230,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 42338,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42778,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42782,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42783,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42785,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42786,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42049,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42666,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 43769,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-12",
    },
    {
      id_registro: 41756,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-3",
    },
    {
      id_registro: 42628,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42689,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-12",
    },
    {
      id_registro: 42736,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43382,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 44083,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44616,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 42346,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 43839,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 45388,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 45223,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45123,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45225,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45226,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45227,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 43221,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43222,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 44546,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44798,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44799,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44800,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44801,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44802,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44803,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44804,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44894,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44895,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45340,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45782,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 44141,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44355,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 45470,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45474,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 46189,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 44796,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 45163,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 46072,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 44234,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-20",
    },
    {
      id_registro: 44597,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44599,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44600,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 45758,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 44140,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-14",
    },
    {
      id_registro: 44182,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44489,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44490,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44491,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44495,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44496,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44497,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44498,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44499,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 45242,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 44701,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44714,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44778,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44786,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44788,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 45206,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45208,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45210,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45562,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45567,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45568,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45572,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45587,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45823,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 43832,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43853,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 43983,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44071,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44261,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-20",
    },
    {
      id_registro: 44833,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44842,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45064,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45319,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45361,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45451,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45452,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45453,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45557,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45571,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 46142,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46210,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-28",
    },
    {
      id_registro: 45469,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 44121,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44122,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44223,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-20",
    },
    {
      id_registro: 44285,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-22",
    },
    {
      id_registro: 44692,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44693,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44695,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-29",
    },
    {
      id_registro: 44696,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44697,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44834,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44841,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44846,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44861,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44864,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44866,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44868,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44869,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44872,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44873,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45172,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45178,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45183,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45185,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 44130,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44136,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44824,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45251,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45565,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45814,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 45816,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45818,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 45836,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45970,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46220,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 44447,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-24",
    },
    {
      id_registro: 45640,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45081,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45085,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45675,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 43291,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-25",
    },
    {
      id_registro: 43427,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-29",
    },
    {
      id_registro: 43341,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-25",
    },
    {
      id_registro: 44844,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44913,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44914,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44985,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 45019,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 45156,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45157,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45228,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45229,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45503,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45525,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45617,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45656,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45737,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45837,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 43668,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 45413,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45984,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 40689,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 45368,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 44609,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 45455,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45588,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45621,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45790,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 43691,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 44993,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 44863,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45614,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 46137,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 45095,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45362,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45366,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45979,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 45982,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-30",
    },
    {
      id_registro: 43436,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-29",
    },
    {
      id_registro: 44622,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44623,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44860,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44874,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44905,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45116,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45232,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45233,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45273,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45275,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45529,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45530,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45531,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45882,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45883,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45884,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 46135,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46140,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 46289,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46291,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46292,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46293,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 45720,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45385,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45532,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 43391,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 44034,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-20",
    },
    {
      id_registro: 44326,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44435,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44509,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44517,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44688,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44736,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44806,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44807,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 44808,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44867,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 44943,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 44944,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 44945,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 44995,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45086,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45089,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45101,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45236,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45279,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45360,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45618,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45628,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 45710,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45980,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 44472,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-24",
    },
    {
      id_registro: 45527,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45822,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45981,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 44260,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-20",
    },
    {
      id_registro: 44441,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-24",
    },
    {
      id_registro: 44442,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-24",
    },
    {
      id_registro: 44443,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-24",
    },
    {
      id_registro: 44556,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44558,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44904,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 45111,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45115,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45142,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45651,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45653,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45654,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45655,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45977,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46294,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46295,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 45794,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 46231,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46045,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 45620,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45732,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45124,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 44450,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 43701,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-6",
    },
    {
      id_registro: 43703,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-6",
    },
    {
      id_registro: 43796,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 44865,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 45472,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45725,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46203,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 42965,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 44358,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 44713,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44726,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 45843,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46205,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46214,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 45121,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 43631,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43720,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-6",
    },
    {
      id_registro: 43721,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-6",
    },
    {
      id_registro: 43085,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 44560,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44561,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45145,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45186,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45664,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45795,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 43682,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44133,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44163,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44212,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44387,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 44397,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 44402,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 44503,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44564,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44619,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44935,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44938,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44939,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45004,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 45139,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45155,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45272,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45425,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45426,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45704,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45705,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45707,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 46020,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46028,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46145,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 44920,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45632,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45889,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45660,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45301,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 43770,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-6",
    },
    {
      id_registro: 43784,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43788,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43791,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43881,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 43932,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 43941,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 43955,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 43957,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 43968,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 43969,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 43990,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-12",
    },
    {
      id_registro: 44069,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44173,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44206,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44218,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44309,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 44400,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-24",
    },
    {
      id_registro: 44507,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44533,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44727,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-29",
    },
    {
      id_registro: 44780,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44891,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 44908,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45047,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 45049,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 45063,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45128,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45189,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45212,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45281,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45441,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45510,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45703,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45711,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45833,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45841,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45914,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45919,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46091,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46102,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46172,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46179,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46202,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46236,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46240,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46276,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 46277,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-02",
    },
    {
      id_registro: 42917,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-17",
    },
    {
      id_registro: 44651,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 45467,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 44311,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 44876,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45324,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 42758,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-14",
    },
    {
      id_registro: 44761,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 44972,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 45240,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45471,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45490,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45666,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 44576,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44837,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45113,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45374,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45414,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 44268,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-24",
    },
    {
      id_registro: 44433,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44437,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44953,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 43823,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44323,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44493,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44797,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 43772,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 45100,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 44383,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 45476,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 43888,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44743,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 45280,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45481,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 43898,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44937,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45521,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 44757,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 42906,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-17",
    },
    {
      id_registro: 43971,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 45381,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 44875,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45104,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 44544,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 31670,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31692,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31743,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31842,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31949,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32030,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32031,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32281,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 32285,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32388,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32389,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32392,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32396,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32532,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32609,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32716,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32768,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32794,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 33051,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33201,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 33448,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33454,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33467,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33470,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33479,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33510,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33612,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33676,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33867,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33925,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34066,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34075,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34098,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34114,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34153,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34209,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34256,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34352,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 34372,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34501,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34514,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34631,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34642,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34752,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34761,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34793,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34871,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34883,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 34972,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34975,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34979,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35021,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35028,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35035,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35042,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35064,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35079,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35087,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35141,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35266,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35270,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35393,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35462,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35531,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35603,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35647,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35882,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35997,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36022,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36177,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36178,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36280,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36313,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36436,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36439,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 36443,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36447,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36559,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36577,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36662,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36667,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36669,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36697,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36698,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36794,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36813,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36831,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 36906,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 36911,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36920,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36930,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36935,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36959,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 36979,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 36980,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37034,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37036,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37041,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37049,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37073,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37104,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37160,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37247,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37248,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37249,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37455,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37457,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37584,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37587,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37607,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37660,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 37684,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37687,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37810,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37813,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37815,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37817,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37828,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37987,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 38001,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 38007,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38046,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38213,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38254,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38279,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38317,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38363,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38367,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38399,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38401,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38408,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38417,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38421,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38435,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38459,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38467,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38583,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38586,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38598,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38756,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38774,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38782,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38830,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38835,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38840,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38911,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38965,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38977,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 38989,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38990,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39091,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39107,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39112,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39205,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39229,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39306,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39330,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39345,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39391,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39408,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39441,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39503,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 39591,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39592,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39711,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39751,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39806,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39811,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39861,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39872,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39898,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39909,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39984,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39990,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39993,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40102,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40104,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40146,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40147,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40148,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40198,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40296,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40297,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40366,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40434,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40627,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40634,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40635,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40643,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40646,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40648,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40694,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40785,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 41062,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41404,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41450,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41453,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41455,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41458,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41461,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41463,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41466,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41514,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41521,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-19",
    },
    {
      id_registro: 41738,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 42081,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 42145,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 44243,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44312,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44604,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 45032,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 45601,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45603,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 31537,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 31597,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31626,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 32039,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32107,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 33364,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33431,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 34046,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 36071,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 38349,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38905,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 42102,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 43934,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-11-12",
    },
    {
      id_registro: 40771,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41059,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 43182,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-09-12",
    },
    {
      id_registro: 42931,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 43293,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 43372,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-10-29",
    },
    {
      id_registro: 43718,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-11-12",
    },
    {
      id_registro: 43719,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43726,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-11-12",
    },
    {
      id_registro: 44330,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 34477,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 34478,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 34479,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 34739,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36492,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36494,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36496,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36498,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36523,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36525,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36528,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36780,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 35733,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 36267,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 45845,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45516,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 44650,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 42884,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-17",
    },
    {
      id_registro: 42579,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 44009,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-14",
    },
    {
      id_registro: 44575,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44577,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44578,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44579,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44687,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-30",
    },
    {
      id_registro: 42251,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-5",
    },
    {
      id_registro: 43803,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 40611,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-06",
    },
    {
      id_registro: 41219,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41229,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41323,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41325,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41328,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41335,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41392,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41518,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-20",
    },
    {
      id_registro: 41524,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41553,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41668,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41669,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41740,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41745,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41746,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41747,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41748,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41749,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41750,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41752,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41754,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41758,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41763,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41764,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 41858,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-28",
    },
    {
      id_registro: 41862,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41863,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-28",
    },
    {
      id_registro: 41868,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41887,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 41917,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-28",
    },
    {
      id_registro: 42008,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 42023,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 42031,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 42032,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 42140,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42142,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42144,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42195,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-5",
    },
    {
      id_registro: 42264,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-5",
    },
    {
      id_registro: 42265,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-5",
    },
    {
      id_registro: 42266,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-3",
    },
    {
      id_registro: 42267,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-3",
    },
    {
      id_registro: 42429,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42430,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42432,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42435,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42476,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42477,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42493,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42494,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42496,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42497,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42501,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42564,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42577,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42580,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42584,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42586,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42598,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42602,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42717,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42718,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42719,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42720,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42721,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42722,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42724,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42726,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42727,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42749,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42753,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42772,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42773,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42774,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42775,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42776,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42819,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42840,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42850,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42851,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42859,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42866,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42883,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42885,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42887,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42893,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42894,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 43035,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 43037,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 43039,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 43151,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43154,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43208,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43210,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43211,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-27",
    },
    {
      id_registro: 43223,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-27",
    },
    {
      id_registro: 43225,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 43314,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 43317,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 43329,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 43332,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 43348,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 43406,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43407,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43410,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43412,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43414,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43457,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43463,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43502,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43505,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43507,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43510,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43544,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43545,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43574,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43575,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43627,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43629,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43640,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43641,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43643,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43644,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43716,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43762,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43763,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43794,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43911,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 43914,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 43919,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44080,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-14",
    },
    {
      id_registro: 44093,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-14",
    },
    {
      id_registro: 44174,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44175,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44270,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44414,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-22",
    },
    {
      id_registro: 44457,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44548,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44550,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44637,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44640,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44644,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44675,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44676,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44677,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44758,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44760,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44826,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44901,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 45131,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45735,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 44313,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 44314,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 44661,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44666,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44667,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44668,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44669,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44670,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44855,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44856,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44898,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 45211,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 44854,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 43539,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 44963,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45335,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 46042,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 43538,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43659,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43713,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-8",
    },
    {
      id_registro: 43952,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 44370,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 44466,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-23",
    },
    {
      id_registro: 44853,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 44929,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 44673,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44930,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 44931,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 45583,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45584,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45597,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 44722,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-29",
    },
    {
      id_registro: 44933,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 45589,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45591,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45777,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 44518,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 44924,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 43747,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 45906,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45008,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45784,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45785,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45786,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 44671,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 45022,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45028,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 45857,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45858,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 46088,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46092,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46096,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 43700,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 45320,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 43916,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 43800,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 43652,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 45517,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 45582,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 43532,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43535,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43536,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43653,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 43654,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 43655,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 44371,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44686,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44980,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-12-5",
    },
    {
      id_registro: 43587,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43589,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43591,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43593,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43594,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-6",
    },
    {
      id_registro: 43596,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 46053,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 45173,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 46039,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 44997,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45254,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45052,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45506,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 30996,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2025-03-06",
    },
    {
      id_registro: 30851,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2025-02-19",
    },
    {
      id_registro: 30988,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2025-03-18",
    },
    {
      id_registro: 30871,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 37458,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37459,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37460,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37461,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37462,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37463,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37465,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37466,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37467,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37468,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37469,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 38484,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 38491,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 38494,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38498,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 38502,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 38506,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 38509,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-05",
    },
    {
      id_registro: 38516,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-28",
    },
    {
      id_registro: 38524,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-05",
    },
    {
      id_registro: 38525,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 38527,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 38528,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 38615,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-13",
    },
    {
      id_registro: 39166,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39336,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-27",
    },
    {
      id_registro: 41100,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 41101,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 41102,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 32153,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32591,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 33273,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33283,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33290,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33821,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-04",
    },
    {
      id_registro: 34429,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 34431,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 34712,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34714,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34796,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34800,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35047,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35486,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35984,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 36203,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36613,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36732,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 37638,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37639,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37676,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 37841,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37866,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38677,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-05",
    },
    {
      id_registro: 38685,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39046,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39056,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 39067,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39068,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 34401,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34808,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 37033,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37062,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37190,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37240,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37495,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37502,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37507,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37540,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37723,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37732,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 38232,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38241,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38315,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38708,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38711,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38714,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38724,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 39617,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39759,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40132,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 44052,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 38839,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 44529,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 44747,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 43311,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43315,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43375,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-10-27",
    },
    {
      id_registro: 43376,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-10-27",
    },
    {
      id_registro: 43377,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-10-27",
    },
    {
      id_registro: 43056,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-11-12",
    },
    {
      id_registro: 43439,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-10-29",
    },
    {
      id_registro: 43672,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-11-3",
    },
    {
      id_registro: 43247,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-10-23",
    },
    {
      id_registro: 32168,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 35604,
      entidad_nombre_res: "QUINTANA ROO",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 34474,
      entidad_nombre_res: "QUINTANA ROO",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 33446,
      entidad_nombre_res: "SAN LUIS POTOSÍ",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 41741,
      entidad_nombre_res: "SAN LUIS POTOSÍ",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41742,
      entidad_nombre_res: "SAN LUIS POTOSÍ",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41743,
      entidad_nombre_res: "SAN LUIS POTOSÍ",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41744,
      entidad_nombre_res: "SAN LUIS POTOSÍ",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41655,
      entidad_nombre_res: "SAN LUIS POTOSÍ",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 39566,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 31650,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 36017,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 38163,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38242,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38243,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 39287,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39289,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-07-27",
    },
    {
      id_registro: 39094,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 42486,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 41499,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41645,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42122,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 42176,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42178,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42682,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 42817,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 45122,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-9",
    },
    {
      id_registro: 45125,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-9",
    },
    {
      id_registro: 45243,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 42381,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-10-3",
    },
    {
      id_registro: 45965,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 44580,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44582,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44790,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-11-30",
    },
    {
      id_registro: 44857,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-2",
    },
    {
      id_registro: 44934,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 45213,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45215,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45224,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45598,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45681,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45686,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45828,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45830,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45886,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45935,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45938,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45947,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45950,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 45969,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46239,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46249,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46256,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46261,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46265,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 41638,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 45218,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45219,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45048,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-7",
    },
    {
      id_registro: 45296,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45307,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45311,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45314,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45316,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45415,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45416,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45417,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45418,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45442,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45443,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45444,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45445,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45446,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45774,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45779,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45780,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45817,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45824,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45848,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45849,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45854,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45881,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45893,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45972,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 46054,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 46059,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 46271,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46275,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46278,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 33626,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 32668,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 34905,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 43216,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-10-27",
    },
    {
      id_registro: 45926,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 35728,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35729,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-01",
    },
    {
      id_registro: 35730,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-01",
    },
    {
      id_registro: 35731,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 35732,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35866,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 35929,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-01",
    },
    {
      id_registro: 35932,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-01",
    },
    {
      id_registro: 36027,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36028,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36029,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36030,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36031,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36032,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36033,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36034,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36035,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36037,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36383,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 36384,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 36386,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 36387,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 36390,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 36622,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36790,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-15",
    },
    {
      id_registro: 36793,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 36801,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-15",
    },
    {
      id_registro: 36802,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 36806,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37175,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37180,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37927,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 39021,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39457,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 39729,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 46043,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 46044,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 46046,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 46153,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 46154,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 46155,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 46156,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 46157,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-12-29",
    },
    {
      id_registro: 41611,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 31554,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 40933,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41269,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-09-19",
    },
    {
      id_registro: 42185,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42243,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 41614,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 42311,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-10-6",
    },
    {
      id_registro: 42314,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-10-6",
    },
    {
      id_registro: 32254,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-04-13",
    },
    {
      id_registro: 32256,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-04-13",
    },
    {
      id_registro: 34997,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35005,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35129,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35083,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 32337,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-04-13",
    },
    {
      id_registro: 32755,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 33759,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-01",
    },
    {
      id_registro: 33847,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33849,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33868,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33930,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 34164,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 34166,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 34168,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 34405,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-11",
    },
    {
      id_registro: 34406,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-11",
    },
    {
      id_registro: 34621,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34622,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 34629,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34834,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35061,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35065,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35069,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35112,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35172,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35193,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35330,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35332,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35447,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-25",
    },
    {
      id_registro: 35571,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35575,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35607,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35937,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36432,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 37106,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37317,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-22",
    },
    {
      id_registro: 32352,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-04-13",
    },
    {
      id_registro: 32741,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32750,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 33933,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 34282,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34573,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 34821,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34833,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 35121,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35122,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 36009,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36013,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 37871,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37873,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-07-26",
    },
    {
      id_registro: 37874,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37097,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 33795,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 39950,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40827,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2025-10-21",
    },
    {
      id_registro: 32135,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32137,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 35851,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 35853,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35856,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 33721,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 34221,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34031,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34895,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 33812,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 34463,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 46079,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 32748,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 33150,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33292,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 33430,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 33957,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 34218,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34278,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34473,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 35349,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 36125,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 37344,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 45574,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 33049,
      entidad_nombre_res: "YUCATÁN",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 35037,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 32119,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32349,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32350,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32563,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 32565,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 44831,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 35120,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35317,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 37096,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36181,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 32159,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 38336,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-07-13",
    },
    {
      id_registro: 38339,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-07-13",
    },
    {
      id_registro: 38340,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-07-13",
    },
    {
      id_registro: 38440,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2025-07-13",
    },
    {
      id_registro: 45646,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45648,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 46104,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 46109,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 46112,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 46114,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 46122,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 32134,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32387,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 40485,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 37699,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 39250,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39420,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39516,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 37679,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 38015,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-06",
    },
    {
      id_registro: 31435,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 32785,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 34770,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 38186,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38705,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 40261,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 41416,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41421,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 31498,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 31542,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 31671,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31689,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31758,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 32044,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32048,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32053,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32145,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32259,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32380,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32381,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32382,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32610,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32932,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 33044,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 33859,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33862,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 34184,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34272,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34470,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34985,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34988,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35523,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35799,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36314,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36795,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 39007,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39772,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 41909,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-26",
    },
    {
      id_registro: 46209,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-28",
    },
    {
      id_registro: 40500,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-09-05",
    },
    {
      id_registro: 31164,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31321,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31423,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31833,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 31956,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32170,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32415,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32496,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 33432,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33703,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 33707,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33837,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33954,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33955,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 35965,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36341,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 32485,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 34064,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 39943,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 38126,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2025-07-26",
    },
    {
      id_registro: 42054,
      entidad_nombre_res: "AGUASCALIENTES",
      fecha_diagnostico: "2025-10-7",
    },
    {
      id_registro: 45578,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 43864,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 45887,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 46087,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 45294,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45903,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45904,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 34921,
      entidad_nombre_res: "TAMAULIPAS",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 41435,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41436,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41502,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41505,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41506,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41572,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41644,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41660,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41661,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 41843,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41852,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 41856,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 41860,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42061,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42062,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42063,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42064,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42065,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42111,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42112,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42115,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42118,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42120,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42121,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42340,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42342,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42343,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42344,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42345,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42350,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42399,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42400,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42401,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42403,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42404,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42411,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42413,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42439,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-8",
    },
    {
      id_registro: 42440,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-8",
    },
    {
      id_registro: 42441,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-8",
    },
    {
      id_registro: 42444,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-7",
    },
    {
      id_registro: 42446,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-7",
    },
    {
      id_registro: 42447,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-7",
    },
    {
      id_registro: 42562,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42574,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42695,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42779,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42781,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42788,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42790,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42791,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42792,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42794,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42845,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42899,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-17",
    },
    {
      id_registro: 42900,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-17",
    },
    {
      id_registro: 42960,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42961,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 42964,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 43045,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-21",
    },
    {
      id_registro: 43046,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-21",
    },
    {
      id_registro: 43280,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-25",
    },
    {
      id_registro: 43294,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-25",
    },
    {
      id_registro: 43431,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-29",
    },
    {
      id_registro: 43484,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-30",
    },
    {
      id_registro: 43695,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-5",
    },
    {
      id_registro: 43696,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-5",
    },
    {
      id_registro: 43829,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43831,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 44024,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44111,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-14",
    },
    {
      id_registro: 44254,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-20",
    },
    {
      id_registro: 44551,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 44678,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 44737,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-1",
    },
    {
      id_registro: 43081,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 41958,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-09-27",
    },
    {
      id_registro: 42349,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42692,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42842,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42844,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42901,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-17",
    },
    {
      id_registro: 42902,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-17",
    },
    {
      id_registro: 43320,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-25",
    },
    {
      id_registro: 43487,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-30",
    },
    {
      id_registro: 43715,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-14",
    },
    {
      id_registro: 43833,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 43838,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 44179,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 44252,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44253,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-19",
    },
    {
      id_registro: 44679,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-28",
    },
    {
      id_registro: 45271,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 45835,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 41755,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 41880,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 41884,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 41888,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42007,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42026,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42174,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42347,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-4",
    },
    {
      id_registro: 42436,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-7",
    },
    {
      id_registro: 42437,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-7",
    },
    {
      id_registro: 42438,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-7",
    },
    {
      id_registro: 42592,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42642,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-11",
    },
    {
      id_registro: 42925,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-18",
    },
    {
      id_registro: 43000,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 43060,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 43063,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 43112,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-23",
    },
    {
      id_registro: 43113,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-23",
    },
    {
      id_registro: 43114,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-23",
    },
    {
      id_registro: 43143,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-23",
    },
    {
      id_registro: 43144,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-23",
    },
    {
      id_registro: 43283,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-25",
    },
    {
      id_registro: 43353,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-29",
    },
    {
      id_registro: 43452,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43476,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 43568,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-6",
    },
    {
      id_registro: 43570,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-6",
    },
    {
      id_registro: 43775,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 44266,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-11-20",
    },
    {
      id_registro: 45364,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45358,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45974,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 42332,
      entidad_nombre_res: "AGUASCALIENTES",
      fecha_diagnostico: "2025-10-3",
    },
    {
      id_registro: 45378,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 44848,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 44849,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 44850,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45291,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 44653,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 45334,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45592,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45126,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 45406,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 45831,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 45547,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45377,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45383,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 45609,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45333,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 36518,
      entidad_nombre_res: "BAJA CALIFORNIA SUR",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 36521,
      entidad_nombre_res: "BAJA CALIFORNIA SUR",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 36522,
      entidad_nombre_res: "BAJA CALIFORNIA SUR",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37157,
      entidad_nombre_res: "BAJA CALIFORNIA SUR",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37238,
      entidad_nombre_res: "BAJA CALIFORNIA SUR",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37239,
      entidad_nombre_res: "BAJA CALIFORNIA SUR",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37332,
      entidad_nombre_res: "BAJA CALIFORNIA SUR",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37691,
      entidad_nombre_res: "BAJA CALIFORNIA SUR",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37950,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 39062,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39082,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39380,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39414,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39444,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 32263,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32265,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32267,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32268,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32886,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 39393,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 33419,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 40477,
      entidad_nombre_res: "CAMPECHE",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 34743,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34744,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34819,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 34965,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35390,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 38543,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38545,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38546,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38547,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38549,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38550,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38552,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38553,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38554,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38555,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38556,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38557,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38558,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38559,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38560,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38561,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38562,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38563,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38564,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38565,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38781,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38783,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38786,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 34666,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-05-18",
    },
    {
      id_registro: 34675,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-05-18",
    },
    {
      id_registro: 33600,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33601,
      entidad_nombre_res: "ZACATECAS",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 35350,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 37421,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 39359,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39836,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39924,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40123,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 41245,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 36715,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 37981,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 39211,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39292,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39696,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39697,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39794,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 37819,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 36692,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 39838,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 36809,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37037,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37737,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 39218,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 40165,
      entidad_nombre_res: "COAHUILA",
      fecha_diagnostico: "2025-10-20",
    },
    {
      id_registro: 46190,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46191,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46192,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46194,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46195,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 45268,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45269,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45523,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45915,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46134,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 45731,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 46011,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46022,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46025,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46027,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46034,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45411,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 40660,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 45912,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45554,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 42284,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-10-29",
    },
    {
      id_registro: 42378,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 42379,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2025-11-14",
    },
    {
      id_registro: 45402,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45625,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 46232,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-28",
    },
    {
      id_registro: 46056,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 45282,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 46047,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-28",
    },
    {
      id_registro: 38157,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-07-26",
    },
    {
      id_registro: 45460,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45502,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45541,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45029,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-7",
    },
    {
      id_registro: 46093,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 45804,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45839,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 46237,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-28",
    },
    {
      id_registro: 46272,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-28",
    },
    {
      id_registro: 45437,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45302,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45553,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45954,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 46000,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46001,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46013,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46014,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46019,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 45913,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45427,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45511,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 45512,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 45009,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-7",
    },
    {
      id_registro: 44296,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 44480,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 45877,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45902,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45911,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45068,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 45069,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 45194,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45300,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45303,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45420,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-14",
    },
    {
      id_registro: 45599,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45600,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45680,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45687,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45688,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45754,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45759,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45867,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45870,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45873,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45874,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45878,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45879,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45880,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45888,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45900,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45901,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 46101,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46113,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46117,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46121,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46160,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-28",
    },
    {
      id_registro: 46248,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-28",
    },
    {
      id_registro: 45204,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 45395,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45428,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45430,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45434,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45595,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45905,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45298,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45872,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45959,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 45435,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45436,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 43846,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 45317,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45811,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45306,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45308,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45546,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45549,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45551,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45576,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45820,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 46252,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-28",
    },
    {
      id_registro: 44614,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-4",
    },
    {
      id_registro: 45035,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-6",
    },
    {
      id_registro: 45293,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45312,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45396,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45398,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45399,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-13",
    },
    {
      id_registro: 45439,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45440,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 45499,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 45504,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 45513,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 45570,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-17",
    },
    {
      id_registro: 45803,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45806,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45810,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45821,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45865,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45869,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45871,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45907,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45908,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45909,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45910,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45956,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-25",
    },
    {
      id_registro: 45957,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 45962,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-23",
    },
    {
      id_registro: 46089,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 46097,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-27",
    },
    {
      id_registro: 45750,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 46067,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 46069,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 45718,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45724,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-20",
    },
    {
      id_registro: 45829,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45948,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-24",
    },
    {
      id_registro: 46175,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-28",
    },
    {
      id_registro: 46062,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 45742,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45746,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45850,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45852,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45853,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45856,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45864,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45866,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-21",
    },
    {
      id_registro: 45936,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 45937,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 45939,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 46061,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 46099,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 46150,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-26",
    },
    {
      id_registro: 31481,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31582,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31646,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31761,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31821,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31902,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31989,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32175,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32186,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32249,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32276,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32298,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32488,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32660,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32772,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32852,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32941,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32955,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32977,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33055,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33095,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33099,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33117,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33246,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 33329,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33350,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33351,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33360,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33361,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33492,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33513,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33623,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33808,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33811,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33844,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33851,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33852,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34001,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34002,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34003,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34045,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 34127,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 34408,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34412,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34515,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34526,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34547,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34554,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34565,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34626,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34673,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34767,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34852,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34857,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34882,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34940,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34954,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35049,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35053,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35056,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35140,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35145,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35171,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35209,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35260,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35417,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35596,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35658,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35663,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35665,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35688,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35744,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 35750,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 35812,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 35875,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 35880,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 35888,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 36000,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36003,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36171,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36242,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36262,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36266,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36274,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36277,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36334,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36456,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36550,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36653,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36947,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37028,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37492,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37551,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37681,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37736,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37879,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 38017,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38108,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38194,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38200,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38209,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38211,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38291,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38302,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38422,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38428,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38641,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38698,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 39018,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39216,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39337,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39401,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39619,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 40435,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 41959,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 31520,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 31547,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31732,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 31733,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 32033,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32038,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32497,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32512,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32518,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32854,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32859,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32862,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32864,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32927,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 33114,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33165,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33334,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33584,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33585,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33645,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33866,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33871,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33977,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34151,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34199,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34240,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34781,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34785,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34855,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34864,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35029,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35032,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35162,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35269,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35397,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35556,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35756,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35819,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 36146,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36247,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36814,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 37366,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37523,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 37811,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 38117,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38469,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38503,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38514,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38903,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38979,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39241,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39308,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39311,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39804,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 40856,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-05",
    },
    {
      id_registro: 42158,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42751,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-7",
    },
    {
      id_registro: 42969,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-20",
    },
    {
      id_registro: 43174,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-23",
    },
    {
      id_registro: 43395,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-29",
    },
    {
      id_registro: 45534,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 35111,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 39515,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 44070,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 31981,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32050,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32901,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32959,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33106,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33190,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33520,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33978,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34704,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34886,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35105,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35514,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35621,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35846,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 37423,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37863,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 38052,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38077,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38841,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 40873,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-05",
    },
    {
      id_registro: 41814,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 32627,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 33349,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 34213,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34346,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34880,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34963,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35174,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35667,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 35952,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36060,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36147,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36421,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36819,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 37130,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37279,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37391,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37395,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37398,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37403,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37408,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37416,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37586,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37596,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37989,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38042,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38047,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38192,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38488,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38906,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39318,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39443,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39501,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 39535,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39603,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39875,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39985,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40159,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40267,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40440,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40501,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40782,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-05",
    },
    {
      id_registro: 41602,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-22",
    },
    {
      id_registro: 32685,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32688,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 33206,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33906,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33912,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33926,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33998,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34101,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34534,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34658,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 35619,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 36463,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36465,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36582,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36776,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37186,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37594,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 38210,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38464,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38838,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 39170,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39338,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39360,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39929,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40317,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40319,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40851,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 40881,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41106,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 42523,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 31583,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 32067,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32172,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32796,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32827,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 33764,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33967,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34237,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 36063,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36742,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 38297,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 40658,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 42171,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 32040,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32705,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 33134,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33209,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 33527,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 34344,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34457,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34558,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34678,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34687,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34757,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34987,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35039,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35044,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35050,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35322,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35392,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35463,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35474,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35490,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35568,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35573,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35746,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35893,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35980,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36093,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36114,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36435,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36438,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36442,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36553,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36558,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36642,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36768,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36907,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36909,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 37045,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37678,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37685,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37689,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37690,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37773,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37852,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37881,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37883,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37913,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37918,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 38040,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38114,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38145,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38184,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38189,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38481,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38487,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38596,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38599,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38694,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38915,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38918,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38978,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 39113,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39115,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39223,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39224,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-10",
    },
    {
      id_registro: 39227,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39417,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 39630,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39661,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 40017,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40019,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40075,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40080,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40311,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40449,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40466,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40467,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 41084,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 41117,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41433,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41540,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-22",
    },
    {
      id_registro: 41687,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 31500,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31516,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 31585,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31686,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 32339,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32346,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-06",
    },
    {
      id_registro: 32523,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32654,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32691,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32692,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32693,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32879,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32983,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 33043,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 33426,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 33427,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33599,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33621,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33953,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 34173,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34174,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34453,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34620,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34832,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 35689,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35690,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35692,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35956,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36012,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36156,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36159,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36400,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36500,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36503,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 36704,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36705,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36706,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36871,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36877,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37021,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37200,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37202,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37270,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37282,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37283,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37299,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37362,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37442,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37499,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37501,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37505,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37674,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 38523,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38531,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38534,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38643,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38647,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38666,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38669,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38713,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38715,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38822,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38936,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38946,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39029,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39030,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39254,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39396,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39627,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 40113,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40433,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 40514,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40515,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40516,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40690,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40779,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 41067,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41237,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-12",
    },
    {
      id_registro: 41389,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 39031,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39822,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 40979,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 38991,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39193,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 45376,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-16",
    },
    {
      id_registro: 34791,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 37194,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37671,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 39552,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39555,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39558,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39768,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 35116,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35524,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 36189,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 37772,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 39815,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 34587,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 36614,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36616,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 38819,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 32566,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 37438,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 39889,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39892,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39893,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39896,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39900,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39992,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 39995,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 39997,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39998,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40001,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40002,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40005,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40006,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40008,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40009,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40013,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40014,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40015,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40020,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40021,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40022,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40024,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40025,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40026,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40027,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40028,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40030,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40323,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40325,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40326,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40329,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40331,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40332,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40335,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40428,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40650,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40654,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40655,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40657,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 37057,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 41045,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 31837,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31862,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 33102,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 37734,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 38171,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38821,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 39236,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39237,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39238,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 31469,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31540,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 31576,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31621,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 31623,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 32211,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32242,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32443,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32706,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 33222,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33488,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 33495,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 33622,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33850,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 34238,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34527,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34532,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34698,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34951,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35539,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35574,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35996,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36910,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 36921,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 35197,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 37506,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37944,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 38998,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39602,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39611,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 40468,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40985,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41060,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41423,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 31933,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32041,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32233,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32367,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32477,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32710,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32743,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32752,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32753,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32791,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 33437,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33552,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33956,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34106,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34320,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34480,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34516,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34665,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34754,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34863,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34898,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35026,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35036,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35586,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35801,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35899,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 35975,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 35977,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36234,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36404,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36405,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36406,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36410,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36638,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36647,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36766,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36830,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36843,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36867,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36878,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 36903,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36923,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 37040,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37044,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37285,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37347,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37348,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 37349,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37434,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37443,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37471,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37472,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37473,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37606,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37675,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37719,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37760,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37784,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37864,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 38150,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38176,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38178,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-10",
    },
    {
      id_registro: 38414,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38418,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38442,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38542,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38588,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38591,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38975,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39084,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39299,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39301,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39302,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39303,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39322,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39587,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39642,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39693,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39842,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39844,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39852,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39855,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 40138,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40415,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40700,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40773,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 41384,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41520,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 43236,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 43913,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 30867,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-02-25",
    },
    {
      id_registro: 30911,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-08",
    },
    {
      id_registro: 31089,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-20",
    },
    {
      id_registro: 31110,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-20",
    },
    {
      id_registro: 31112,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31114,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31130,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-13",
    },
    {
      id_registro: 31150,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31184,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-21",
    },
    {
      id_registro: 31250,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31252,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31324,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31327,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31399,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31401,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31456,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31593,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 31603,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 31604,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 31673,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31745,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31828,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 31832,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31836,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31879,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31927,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31941,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31944,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31947,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31951,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31952,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31967,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-06",
    },
    {
      id_registro: 32035,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32139,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32141,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32152,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32158,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32222,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32353,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32409,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32413,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32642,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32645,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32697,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32703,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32848,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32883,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32888,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32891,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32925,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32938,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 33069,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33217,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33227,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33347,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33354,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 34374,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34382,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34706,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 35220,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35611,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-18",
    },
    {
      id_registro: 36109,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 35136,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 32004,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32072,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32089,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32117,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 32155,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32157,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32209,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 32270,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32289,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32327,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32411,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32425,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32834,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 33216,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 33223,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33533,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33555,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33562,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 34108,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 34126,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 34430,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34455,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34569,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34613,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34618,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34932,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34962,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35091,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35127,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35643,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35646,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35649,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 36111,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36369,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 37242,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37334,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 38508,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 40498,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40899,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-05",
    },
    {
      id_registro: 31991,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32495,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32630,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 33475,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 33755,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33780,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 35043,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 35273,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35296,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 36089,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 37386,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 38996,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 32507,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32638,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32964,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 39507,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 40503,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 41251,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-12",
    },
    {
      id_registro: 42095,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41040,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41235,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41787,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 39774,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39775,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39777,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 43675,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-5",
    },
    {
      id_registro: 42116,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-1",
    },
    {
      id_registro: 42536,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 32243,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32687,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 33352,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 35530,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35721,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 36138,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 36318,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36873,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 36882,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37100,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37105,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37140,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37184,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37373,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37377,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37642,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37761,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37888,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 38028,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38029,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38030,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38160,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38246,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-10",
    },
    {
      id_registro: 38574,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38575,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38653,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38745,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38824,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38825,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38827,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38828,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38881,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38885,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38887,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38909,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38938,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38939,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38940,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38941,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38957,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39026,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39132,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39142,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39212,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39258,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39273,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39274,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39368,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39369,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39370,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39372,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39421,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39422,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39423,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39425,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39427,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39428,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39430,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 39447,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 39481,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-01",
    },
    {
      id_registro: 39523,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39533,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39585,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39594,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39596,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39597,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39604,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39607,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39609,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39670,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39695,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39700,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39702,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39718,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39738,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39752,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39843,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39868,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39869,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39873,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-12",
    },
    {
      id_registro: 39877,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 39878,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39885,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39890,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39901,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39930,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39935,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39936,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39940,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39962,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 39994,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40000,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40031,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40034,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40056,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40166,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40211,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40252,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40253,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40301,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40345,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40347,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40349,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40383,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40392,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40399,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40408,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40409,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40410,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 40412,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40417,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40418,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40419,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40420,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40422,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40423,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40424,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40425,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40436,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40479,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40529,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 40530,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 40531,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 40628,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 40629,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40644,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40684,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40764,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40823,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40825,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40828,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40829,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40830,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40831,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 40934,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40937,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40938,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40939,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40940,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40942,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40943,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40945,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40946,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40947,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40948,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40949,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40950,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40951,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40998,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-09",
    },
    {
      id_registro: 41012,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41094,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41097,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41099,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41118,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 41169,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-12",
    },
    {
      id_registro: 41170,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 41227,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-12",
    },
    {
      id_registro: 41296,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 41299,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-15",
    },
    {
      id_registro: 41300,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-15",
    },
    {
      id_registro: 41371,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41429,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41434,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41498,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-19",
    },
    {
      id_registro: 41656,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41657,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41658,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41659,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 42087,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 42428,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-7",
    },
    {
      id_registro: 42555,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-15",
    },
    {
      id_registro: 42653,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 42674,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 43022,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-21",
    },
    {
      id_registro: 43115,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 43116,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 43209,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43213,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43214,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43215,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43217,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43218,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-24",
    },
    {
      id_registro: 43358,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-28",
    },
    {
      id_registro: 43424,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-29",
    },
    {
      id_registro: 43877,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 33834,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 35234,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 37298,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 39717,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 34983,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35396,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35935,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 36420,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36424,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36428,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 37173,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 37210,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37228,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 40473,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 41238,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-12",
    },
    {
      id_registro: 35236,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 35936,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 36470,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36949,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37822,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37877,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 36419,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 34172,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 41534,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-22",
    },
    {
      id_registro: 41709,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41710,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41712,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 41714,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 31882,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31891,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31992,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32402,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32404,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32430,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32641,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32774,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32775,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 33157,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 33377,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33381,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33444,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33445,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33452,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33455,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33640,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33659,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33682,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33689,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33693,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33698,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33830,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34076,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34078,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34443,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34446,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34452,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34720,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 34727,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34728,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34729,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34730,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34734,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34735,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34736,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34737,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34758,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 34759,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34903,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34911,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 34982,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35159,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35164,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35215,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35217,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35221,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35223,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35230,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35235,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35283,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35367,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35717,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35757,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 36127,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36270,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 40201,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 31391,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-25",
    },
    {
      id_registro: 31392,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-25",
    },
    {
      id_registro: 31393,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-25",
    },
    {
      id_registro: 31394,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-25",
    },
    {
      id_registro: 31395,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31400,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-25",
    },
    {
      id_registro: 31428,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31965,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31968,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31973,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31974,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32515,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 33293,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 34102,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34306,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34919,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34944,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34948,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 36131,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 36353,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 37023,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37154,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37155,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 39614,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 41529,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 31525,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 33477,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 35007,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35015,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35720,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 39488,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 40880,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 33680,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 35054,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 37498,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 38676,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 31849,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31850,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31926,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 33428,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34497,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 35179,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35968,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36151,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36446,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36685,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36915,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37022,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37024,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37139,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 32144,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 33627,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34636,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35543,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 36641,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 37357,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37440,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 39600,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 35960,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36415,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36649,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36902,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37893,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 38177,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38538,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38539,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38540,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38607,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 39023,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 34113,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34648,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 35046,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 36409,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36904,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37845,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 31985,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 33478,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34544,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 35629,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 37211,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 39013,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 41128,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-12",
    },
    {
      id_registro: 42625,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-4",
    },
    {
      id_registro: 43801,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-11",
    },
    {
      id_registro: 32765,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33614,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34503,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 42907,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 33615,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 34069,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 38303,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 31675,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31996,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32332,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32700,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32918,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33395,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 35095,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35316,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35609,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35614,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 37437,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37698,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37701,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37702,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37755,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37934,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 35701,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 45739,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 34809,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37392,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 39987,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 34438,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 36472,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36798,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 37019,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37726,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37733,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 41513,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-22",
    },
    {
      id_registro: 41907,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 45644,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 45647,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 31817,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 34844,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34848,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 34967,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35135,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35139,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 36398,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36481,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 38519,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38520,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38522,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 38717,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39178,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 34331,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34595,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 36890,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36891,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36926,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 31684,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 32042,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 37616,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37746,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37802,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37818,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 39580,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 38172,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38267,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 34969,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 34803,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 31480,
      entidad_nombre_res: "",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31894,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 32006,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 33503,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33831,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33832,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 35180,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 41154,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-15",
    },
    {
      id_registro: 32455,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32456,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32499,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 33508,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 36490,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 37780,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37782,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 38437,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38439,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38744,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 40032,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 41081,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 43092,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 41072,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 33040,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33647,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 36429,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 36430,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 36433,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 36434,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 39834,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40641,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 41274,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-15",
    },
    {
      id_registro: 42086,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 42814,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-22",
    },
    {
      id_registro: 42935,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-27",
    },
    {
      id_registro: 43556,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-5",
    },
    {
      id_registro: 43628,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-5",
    },
    {
      id_registro: 43630,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-5",
    },
    {
      id_registro: 43632,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-5",
    },
    {
      id_registro: 43810,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44094,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44965,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-12",
    },
    {
      id_registro: 45611,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-19",
    },
    {
      id_registro: 45636,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-22",
    },
    {
      id_registro: 36437,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 45555,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 45560,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-18",
    },
    {
      id_registro: 31923,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 32423,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 33550,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 34423,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 35681,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 36495,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 37767,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 39036,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 37880,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 42479,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 42985,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-21",
    },
    {
      id_registro: 42988,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-21",
    },
    {
      id_registro: 42989,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-16",
    },
    {
      id_registro: 42990,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-23",
    },
    {
      id_registro: 43584,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-31",
    },
    {
      id_registro: 45110,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-11",
    },
    {
      id_registro: 43742,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-10",
    },
    {
      id_registro: 32818,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 34099,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 39090,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 40314,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-25",
    },
    {
      id_registro: 40890,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 41120,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 41250,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-15",
    },
    {
      id_registro: 32440,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 33908,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33919,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 33927,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 35633,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35634,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35891,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35894,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36789,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 37814,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 38434,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 38992,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38995,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39126,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39539,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39610,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39618,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39623,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39629,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39847,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39849,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39851,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40124,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40135,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40136,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40137,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40177,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40181,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40233,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-22",
    },
    {
      id_registro: 40612,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40661,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40663,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40667,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40687,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40693,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40697,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40701,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40704,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40896,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40898,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 41028,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41030,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41031,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41032,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41034,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41091,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 41354,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41361,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41363,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41382,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-16",
    },
    {
      id_registro: 41383,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-16",
    },
    {
      id_registro: 41393,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-16",
    },
    {
      id_registro: 41413,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-14",
    },
    {
      id_registro: 41446,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-16",
    },
    {
      id_registro: 41651,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 41906,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-24",
    },
    {
      id_registro: 41908,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41930,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41974,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 42019,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-29",
    },
    {
      id_registro: 42074,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 42358,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-6",
    },
    {
      id_registro: 42416,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 42568,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 43240,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-27",
    },
    {
      id_registro: 44062,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44064,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-13",
    },
    {
      id_registro: 44787,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 45001,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 45003,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-8",
    },
    {
      id_registro: 45245,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 32506,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 31309,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-21",
    },
    {
      id_registro: 31494,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31589,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31781,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31955,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31959,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32663,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32804,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32809,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 33459,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33590,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 34167,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34223,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 34315,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34695,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 35175,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 36370,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36588,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36988,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 36990,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 36991,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 36992,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 36993,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37500,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37745,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 40888,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 40891,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-08",
    },
    {
      id_registro: 32653,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 36615,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36729,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 37233,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 38420,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-10",
    },
    {
      id_registro: 37319,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37792,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37793,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37794,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37795,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37796,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37797,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37798,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-28",
    },
    {
      id_registro: 39685,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-05",
    },
    {
      id_registro: 39687,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39966,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 31162,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31370,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31416,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31436,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31470,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31472,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31473,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31518,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 31519,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 31575,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31628,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31631,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31639,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31746,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31747,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31751,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31756,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31759,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31763,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31772,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31786,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31846,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31854,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31855,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31857,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31858,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31859,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31860,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31957,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 31960,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 31963,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 31970,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 31971,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 31976,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 31998,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 31999,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32058,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32059,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32062,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 32063,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32065,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32073,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32075,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 32077,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32078,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32083,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32085,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32087,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 32090,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32095,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32096,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 32098,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32102,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32104,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32105,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32181,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32191,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32192,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32195,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 32197,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 32200,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 32202,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32235,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32237,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32239,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32240,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32245,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32246,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32247,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32248,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 32397,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32403,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32406,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32408,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32412,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32426,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32427,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32428,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32433,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32436,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32438,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32439,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32513,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32516,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32517,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32525,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32528,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32531,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32535,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32537,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32541,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32543,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32547,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32548,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32554,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32561,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32757,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32758,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32761,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32764,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32779,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32788,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32793,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32795,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32801,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32806,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32810,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32812,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32816,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32819,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32832,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32836,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32838,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32842,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32844,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32853,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32860,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32866,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32877,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32880,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32885,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32897,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32898,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32899,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32902,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32904,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32908,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32909,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32911,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32912,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32913,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32917,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32923,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32926,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32928,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32931,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32933,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32935,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32936,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32940,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32942,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32943,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32944,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32947,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32948,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32949,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32952,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32956,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32957,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32961,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32971,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32973,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32975,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32979,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32981,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32984,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32986,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32988,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32990,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32999,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33004,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33006,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33010,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33016,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33073,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 33075,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 33077,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33081,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33082,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33088,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33091,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33094,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33096,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33098,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33101,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33104,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33105,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33120,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33122,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33123,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33130,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33135,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 33159,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 33164,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 33167,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33174,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 33177,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 33178,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33179,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 33181,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33187,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33188,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 33191,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33193,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33221,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33230,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33236,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33239,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33247,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33250,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33253,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33254,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33258,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33262,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33266,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33268,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33269,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33270,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33274,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33275,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33277,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33279,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33281,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33282,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33284,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33287,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33288,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33289,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33291,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33341,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33344,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33348,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33353,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33362,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33366,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33369,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 33370,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 33372,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 33374,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 33375,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 33378,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 33380,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33384,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 33385,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 33387,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 33390,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33391,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33392,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33396,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33397,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33400,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33402,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33404,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33516,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33517,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33522,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33528,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33531,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33535,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33538,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33542,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-27",
    },
    {
      id_registro: 33549,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33551,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33557,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33563,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-27",
    },
    {
      id_registro: 33565,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33569,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33570,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33609,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33610,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33632,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33637,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33641,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33653,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33657,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33660,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33661,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33664,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33666,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33670,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33672,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33695,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33754,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33757,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33761,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33767,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33768,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33772,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33778,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33779,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33784,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33786,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-08",
    },
    {
      id_registro: 33813,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33870,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33873,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 33875,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33880,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 33886,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33892,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33895,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33900,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33902,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33904,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33905,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33909,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33914,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33915,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33917,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33918,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33921,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33922,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33924,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 33982,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-04",
    },
    {
      id_registro: 33983,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 33988,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33995,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33996,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 33999,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 34000,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34004,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34005,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34006,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34007,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34008,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34009,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34011,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34012,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34015,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34018,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34020,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34021,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34023,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34024,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34067,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34097,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34100,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34103,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34136,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34137,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34142,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34147,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34150,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34227,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 34235,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34239,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34241,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34245,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34248,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34250,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34254,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34348,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34351,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34354,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34355,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34357,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34359,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34362,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34364,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34366,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34367,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34369,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34486,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34487,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34489,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34491,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34494,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34495,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34496,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34548,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34549,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34551,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 34552,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34553,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34557,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34562,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34563,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34564,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34572,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34575,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34577,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34582,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34585,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34588,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34590,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34592,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34593,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34659,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34662,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34664,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34667,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34674,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34766,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34772,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34773,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34774,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34777,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34860,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34861,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34872,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35017,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35018,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35023,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35062,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35066,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35068,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35070,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35073,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35074,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35077,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35080,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35081,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35082,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35085,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35090,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35093,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35094,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35098,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35099,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35100,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35101,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35102,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35184,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35187,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35189,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35195,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35199,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35201,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35202,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35298,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35299,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35300,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35307,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35309,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35311,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35312,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35383,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35384,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35386,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35387,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35388,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35577,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35581,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35582,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35585,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35588,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35590,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35593,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35597,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35601,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35602,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35606,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35608,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35610,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35616,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-29",
    },
    {
      id_registro: 35737,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 35738,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35747,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35751,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35833,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35878,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35961,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 35963,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 35964,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 35976,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36095,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36098,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36099,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36160,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36162,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36166,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36168,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36238,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36239,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36241,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36451,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36453,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36541,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36542,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36635,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36719,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36833,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36834,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 36837,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36912,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36916,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36931,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36932,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36936,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36937,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37052,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37054,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37055,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37117,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37118,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37122,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-21",
    },
    {
      id_registro: 37288,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37289,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37396,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37397,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37399,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37401,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37404,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 37406,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37407,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37411,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37413,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37414,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37419,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37422,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37515,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37516,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37518,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37593,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37599,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37601,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37661,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37662,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37663,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37665,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37738,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37739,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37740,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37743,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37744,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37804,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37821,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37830,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37923,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38016,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 38032,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-10",
    },
    {
      id_registro: 38033,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-10",
    },
    {
      id_registro: 38034,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-10",
    },
    {
      id_registro: 38090,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38091,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38095,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38165,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38166,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38168,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38169,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38260,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38262,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38394,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38395,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38397,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38398,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38458,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38618,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38619,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38832,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38897,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38898,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38974,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38981,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38984,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39092,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39096,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39145,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39210,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39295,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39296,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39300,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39383,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39526,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39527,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39547,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 39648,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39651,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39797,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39800,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39801,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39894,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 39977,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40103,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40105,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40482,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-27",
    },
    {
      id_registro: 40834,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-04",
    },
    {
      id_registro: 42196,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 42495,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-9",
    },
    {
      id_registro: 31568,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31893,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31950,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31958,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31961,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31964,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 31969,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32002,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32003,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32005,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32007,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32010,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32228,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32305,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32445,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32447,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32448,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32449,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32450,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32453,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32503,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32824,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32831,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32850,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32903,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 32907,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32910,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33240,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33678,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33679,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33686,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33691,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33696,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33701,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33708,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33717,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33817,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33879,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 33882,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 33890,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 33893,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 33997,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 34016,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34017,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34019,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34094,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34219,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 34468,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34645,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34647,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34652,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34653,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34660,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34671,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34676,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34680,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34686,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34689,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34696,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34701,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34723,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34724,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34725,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34829,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34830,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 35003,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35076,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35086,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35096,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35123,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35222,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35584,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35589,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35591,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35594,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35671,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 35749,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-31",
    },
    {
      id_registro: 35786,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35787,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35820,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35904,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 35906,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 35911,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 35979,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 35988,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 35993,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36018,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 36019,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 36020,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-01",
    },
    {
      id_registro: 36021,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 36049,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 36068,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 36132,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 36136,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36186,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-07",
    },
    {
      id_registro: 36216,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36275,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36287,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36304,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36344,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36345,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36346,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36348,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36506,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36508,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36509,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36510,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36511,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36512,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36513,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36514,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36515,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36516,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36517,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36519,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36520,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36524,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36526,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36527,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36529,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36533,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36603,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36670,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-13",
    },
    {
      id_registro: 36673,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36675,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36847,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36858,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36859,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36987,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36994,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36995,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36996,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36997,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 36999,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37000,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37001,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37002,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37003,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37004,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37006,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37077,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37078,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37081,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37082,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37256,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37264,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37321,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37328,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37329,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37330,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37374,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37376,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37380,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37384,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37388,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37389,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37429,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37431,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37486,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37595,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37598,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37600,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37602,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37912,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37916,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37917,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37986,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38002,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38004,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38059,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38060,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38061,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38066,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38180,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38185,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38187,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38188,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-3",
    },
    {
      id_registro: 38191,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38193,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38195,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38235,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38238,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38239,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38345,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38347,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38366,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38492,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38496,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38533,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38589,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38679,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38684,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38764,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-18",
    },
    {
      id_registro: 38842,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38908,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38937,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38971,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38993,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39039,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39040,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39095,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39103,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39131,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39310,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39313,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39317,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39386,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 39654,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39746,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39925,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-15",
    },
    {
      id_registro: 40063,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40064,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40068,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40154,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40155,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40157,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40175,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40218,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-20",
    },
    {
      id_registro: 40343,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-26",
    },
    {
      id_registro: 40576,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 40577,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 40593,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-29",
    },
    {
      id_registro: 40703,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40736,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 41042,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41153,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-15",
    },
    {
      id_registro: 41317,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-17",
    },
    {
      id_registro: 41410,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 41780,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-25",
    },
    {
      id_registro: 44540,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 30991,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-21",
    },
    {
      id_registro: 37089,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 37094,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 38765,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 40749,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 40750,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40751,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-05",
    },
    {
      id_registro: 40752,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 40754,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40755,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 33457,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33593,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 34386,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 32631,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 37983,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 38948,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 38949,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 42097,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 31180,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-15",
    },
    {
      id_registro: 31305,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-17",
    },
    {
      id_registro: 31450,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31725,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 31730,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31802,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31803,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31804,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31809,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31911,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31912,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31914,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31916,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 32587,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-01",
    },
    {
      id_registro: 32598,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32599,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32718,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32734,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32807,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32813,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32820,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32829,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32833,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32841,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32851,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32861,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32863,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32865,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33263,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33280,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33286,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33296,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33298,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33796,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 34105,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34107,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34111,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34568,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34571,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34584,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34589,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34596,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34598,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34600,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34602,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34684,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34691,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34925,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35241,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35246,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35249,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35314,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35416,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35418,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35488,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35491,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35493,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35494,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35496,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35776,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 36074,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36076,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36081,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36083,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36088,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36091,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36096,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36103,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36176,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36191,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36196,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36201,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36289,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36299,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36302,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36305,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36605,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36606,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36609,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36722,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36725,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36976,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36977,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36978,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36982,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36983,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37090,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37166,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37227,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37230,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37231,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37451,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37452,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37628,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37635,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37637,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37640,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37643,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37644,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37645,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37646,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37647,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37669,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37846,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37850,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37851,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 37854,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 37957,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37959,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37961,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37962,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 37963,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37964,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37966,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37967,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37968,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37969,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37971,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37972,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-27",
    },
    {
      id_registro: 37973,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38094,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38096,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38100,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38101,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38102,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38103,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38214,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38219,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38273,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38275,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38283,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 38284,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 38477,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38505,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38630,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-14",
    },
    {
      id_registro: 38687,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38690,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38802,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38814,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38815,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38816,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 38817,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 39054,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39232,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39234,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 39298,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39349,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39437,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39438,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39454,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 39459,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 39593,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-08",
    },
    {
      id_registro: 39714,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-11",
    },
    {
      id_registro: 41055,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 42319,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-6",
    },
    {
      id_registro: 31306,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31570,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31571,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31579,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31767,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31864,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 31865,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31972,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32028,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32032,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32046,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32336,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 32526,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32538,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32542,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32546,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32567,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32596,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32597,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32868,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 33301,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33318,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33465,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33716,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33823,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 34290,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34293,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34394,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34509,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34510,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34513,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34517,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34525,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 34820,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 37095,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37232,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 38637,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38807,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 39251,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39266,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 34247,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 30922,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30923,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30924,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30925,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-08",
    },
    {
      id_registro: 30939,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-08",
    },
    {
      id_registro: 30957,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30961,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30975,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30976,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30977,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30980,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30981,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30982,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-02-27",
    },
    {
      id_registro: 30983,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30985,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 30986,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-02-27",
    },
    {
      id_registro: 30989,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 30992,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 31100,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31125,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-12",
    },
    {
      id_registro: 31126,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31131,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31144,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-20",
    },
    {
      id_registro: 31145,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31152,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-08",
    },
    {
      id_registro: 31156,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-10",
    },
    {
      id_registro: 31159,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-10",
    },
    {
      id_registro: 31160,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-10",
    },
    {
      id_registro: 31161,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-11",
    },
    {
      id_registro: 31169,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-12",
    },
    {
      id_registro: 31173,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-21",
    },
    {
      id_registro: 31174,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-12",
    },
    {
      id_registro: 31182,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-15",
    },
    {
      id_registro: 31187,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-15",
    },
    {
      id_registro: 31198,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-10",
    },
    {
      id_registro: 31224,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-14",
    },
    {
      id_registro: 31226,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31232,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-14",
    },
    {
      id_registro: 31281,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-20",
    },
    {
      id_registro: 31285,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31290,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-14",
    },
    {
      id_registro: 31291,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-13",
    },
    {
      id_registro: 31292,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-10",
    },
    {
      id_registro: 31312,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31316,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31318,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-21",
    },
    {
      id_registro: 31353,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31357,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-24",
    },
    {
      id_registro: 31384,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-24",
    },
    {
      id_registro: 31385,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-24",
    },
    {
      id_registro: 31403,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31407,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31413,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31415,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31417,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31419,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31434,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-21",
    },
    {
      id_registro: 31438,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-21",
    },
    {
      id_registro: 31439,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31440,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31444,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31445,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 31446,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31447,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31448,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31449,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 31454,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31457,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31489,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-21",
    },
    {
      id_registro: 31490,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-23",
    },
    {
      id_registro: 31491,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31492,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31506,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31527,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31532,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-20",
    },
    {
      id_registro: 31533,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 31534,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 31535,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-26",
    },
    {
      id_registro: 31544,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-27",
    },
    {
      id_registro: 31546,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-24",
    },
    {
      id_registro: 31569,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31572,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31581,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31587,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31588,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31609,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 31610,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 31613,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 31614,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 31657,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31658,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31659,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31660,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31661,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31662,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 31663,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 31664,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 31665,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31666,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 31667,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31693,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31694,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31695,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31696,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 31697,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31698,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31700,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31702,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31705,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31706,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 31708,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31709,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 31711,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31712,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31713,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 31714,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31717,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31721,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 31723,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 31724,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31727,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 31728,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 31729,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 31731,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 31783,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31795,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31801,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31806,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31807,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-05",
    },
    {
      id_registro: 31812,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31838,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31861,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31863,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31906,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31908,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31909,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 31945,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 31977,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 32014,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-29",
    },
    {
      id_registro: 32015,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32016,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32017,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32019,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32020,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32021,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32022,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32023,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32024,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32025,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32027,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32043,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32057,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32061,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32064,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32066,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 32069,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 32074,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 32076,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 32079,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 32084,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 32086,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32088,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32092,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32099,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32101,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32112,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32113,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 32114,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32115,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32132,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32133,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-12",
    },
    {
      id_registro: 32140,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32160,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32162,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32164,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32166,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32169,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32171,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32173,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32176,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32180,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32183,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32185,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32187,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32188,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32190,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32196,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32198,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32203,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32206,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32207,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 32288,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32294,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 32301,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32320,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32323,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32340,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32345,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32400,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32410,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32421,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 32459,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32464,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32465,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32466,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 32467,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32468,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32491,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32511,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32521,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32524,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32527,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32533,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32534,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32540,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32549,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32557,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32562,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32570,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32571,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-19",
    },
    {
      id_registro: 32574,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32578,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32579,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32580,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32581,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32582,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32584,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32585,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32586,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32588,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32589,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32593,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32594,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32595,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32615,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32646,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32732,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-23",
    },
    {
      id_registro: 32733,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32735,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32736,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32738,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32739,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32742,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32744,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 32745,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32746,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32747,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32770,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32773,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32776,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32778,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32782,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32783,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32784,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32786,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32789,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32792,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32798,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32815,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32830,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32835,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32837,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32840,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32847,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32855,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32857,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32867,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32870,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32872,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32875,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32878,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32881,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32882,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-24",
    },
    {
      id_registro: 32884,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32945,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 32951,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32958,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32962,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 32965,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-18",
    },
    {
      id_registro: 32974,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 32992,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 33003,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33005,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33008,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33013,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33014,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33015,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33018,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33022,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 33023,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33025,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33028,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-25",
    },
    {
      id_registro: 33030,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 33032,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33103,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33107,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33111,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33119,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33121,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33124,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33126,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33129,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33136,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33138,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33139,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33141,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33143,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-26",
    },
    {
      id_registro: 33255,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 33259,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 33299,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 33300,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33303,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33310,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33312,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33313,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33314,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33315,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33316,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33317,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33319,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33320,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33321,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33322,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33323,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33464,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33472,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33481,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33487,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33574,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33576,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33578,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33580,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33594,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33595,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33597,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 33628,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33631,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33723,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33724,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33725,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33726,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33829,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 34115,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34116,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34124,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34129,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34133,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 34134,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34185,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 34192,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34198,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34259,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 34266,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-08",
    },
    {
      id_registro: 34271,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-01",
    },
    {
      id_registro: 34273,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-28",
    },
    {
      id_registro: 34275,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 34276,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 34279,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-31",
    },
    {
      id_registro: 34280,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34284,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34285,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 34286,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 34289,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 34291,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 34292,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 34294,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 34296,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 34307,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 34308,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 34309,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 34310,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 34313,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 34317,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-30",
    },
    {
      id_registro: 34318,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 34319,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-13",
    },
    {
      id_registro: 34321,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-13",
    },
    {
      id_registro: 34324,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-15",
    },
    {
      id_registro: 34327,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-13",
    },
    {
      id_registro: 34328,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 34332,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-13",
    },
    {
      id_registro: 34339,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-14",
    },
    {
      id_registro: 34389,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34392,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34395,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 34506,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34520,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34522,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34536,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 34542,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34545,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34818,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-19",
    },
    {
      id_registro: 34952,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34953,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34958,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35055,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35059,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35072,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35078,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35206,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35208,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35211,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35250,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35251,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35319,
      entidad_nombre_res: "",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35329,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35431,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35432,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35461,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-22",
    },
    {
      id_registro: 35464,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35465,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 35466,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35546,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35549,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35771,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35775,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35782,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 35831,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 36115,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 36301,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 36303,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 36620,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36621,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36637,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36739,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36747,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 37031,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37093,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37168,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37269,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 37325,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37448,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37449,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37629,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-27",
    },
    {
      id_registro: 37709,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37836,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-03",
    },
    {
      id_registro: 38119,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 38923,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38999,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39248,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39252,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39465,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-04",
    },
    {
      id_registro: 40653,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40671,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 40674,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-02",
    },
    {
      id_registro: 41085,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41086,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-10",
    },
    {
      id_registro: 41088,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-11",
    },
    {
      id_registro: 41211,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-12",
    },
    {
      id_registro: 41264,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-15",
    },
    {
      id_registro: 41408,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-18",
    },
    {
      id_registro: 31307,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-21",
    },
    {
      id_registro: 31616,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 31617,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-02",
    },
    {
      id_registro: 32013,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 32644,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32889,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33591,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33752,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33819,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 33820,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 34604,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 35340,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-26",
    },
    {
      id_registro: 36108,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36209,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36356,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36358,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36604,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 37324,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 39120,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39915,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 40560,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-01",
    },
    {
      id_registro: 32108,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-11",
    },
    {
      id_registro: 32110,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 32637,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32639,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32800,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33145,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33146,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33161,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33173,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33176,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33238,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 33242,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33249,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33252,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33256,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-28",
    },
    {
      id_registro: 33765,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33769,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33774,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33788,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 33789,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33791,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 34146,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34155,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 34156,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34165,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34507,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34511,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34605,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-15",
    },
    {
      id_registro: 34792,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35160,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35168,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35173,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 36105,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36956,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 32034,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-09",
    },
    {
      id_registro: 32501,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-02",
    },
    {
      id_registro: 32505,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32509,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-17",
    },
    {
      id_registro: 32510,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32617,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32620,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32623,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32930,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 32976,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 33197,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33636,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 34158,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34263,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-04",
    },
    {
      id_registro: 34970,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35240,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35470,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35679,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-03",
    },
    {
      id_registro: 36097,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36466,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-18",
    },
    {
      id_registro: 37161,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37165,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-25",
    },
    {
      id_registro: 37312,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37316,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37765,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 38266,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-15",
    },
    {
      id_registro: 39245,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 35237,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 36086,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36592,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 37234,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-26",
    },
    {
      id_registro: 37953,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38025,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 38883,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39413,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 40728,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-03",
    },
    {
      id_registro: 41541,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-23",
    },
    {
      id_registro: 42205,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-2",
    },
    {
      id_registro: 39451,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 37954,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 37956,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-07",
    },
    {
      id_registro: 39108,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 39327,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-28",
    },
    {
      id_registro: 34926,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 32037,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-10",
    },
    {
      id_registro: 33713,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-07",
    },
    {
      id_registro: 34530,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-03",
    },
    {
      id_registro: 36596,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 36749,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36785,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-16",
    },
    {
      id_registro: 36952,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36963,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36984,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36985,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 36986,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-19",
    },
    {
      id_registro: 37087,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-14",
    },
    {
      id_registro: 37172,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 37174,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37176,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37326,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 37704,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37705,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37706,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-22",
    },
    {
      id_registro: 37766,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 37938,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-02",
    },
    {
      id_registro: 37952,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-29",
    },
    {
      id_registro: 38022,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38024,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-08",
    },
    {
      id_registro: 38228,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-16",
    },
    {
      id_registro: 38234,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38309,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-11",
    },
    {
      id_registro: 38682,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38689,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38691,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38696,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38703,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-17",
    },
    {
      id_registro: 38811,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 38831,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 39001,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39008,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-23",
    },
    {
      id_registro: 39116,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-25",
    },
    {
      id_registro: 39242,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39244,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39246,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-24",
    },
    {
      id_registro: 39253,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-29",
    },
    {
      id_registro: 39385,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39404,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-31",
    },
    {
      id_registro: 39545,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-07",
    },
    {
      id_registro: 39631,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39632,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39954,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39955,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39956,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 39958,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-14",
    },
    {
      id_registro: 40038,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40039,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40061,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-19",
    },
    {
      id_registro: 40781,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-30",
    },
    {
      id_registro: 42623,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-10",
    },
    {
      id_registro: 43680,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-11-6",
    },
    {
      id_registro: 37504,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-26",
    },
    {
      id_registro: 38051,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 36612,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-12",
    },
    {
      id_registro: 35840,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 38092,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-09",
    },
    {
      id_registro: 31573,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-29",
    },
    {
      id_registro: 35800,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 32150,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 32225,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32226,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32232,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 32490,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-21",
    },
    {
      id_registro: 33386,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33544,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33558,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33564,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 33571,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33577,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33947,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34224,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34231,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34232,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34236,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 34274,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34333,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34765,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34768,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34912,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35271,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35275,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 38987,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-21",
    },
    {
      id_registro: 39783,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39784,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39785,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39786,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-06",
    },
    {
      id_registro: 39787,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-21",
    },
    {
      id_registro: 40084,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 40086,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40088,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40089,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-18",
    },
    {
      id_registro: 40094,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 40095,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-13",
    },
    {
      id_registro: 40463,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-08-28",
    },
    {
      id_registro: 41925,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-26",
    },
    {
      id_registro: 42295,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-6",
    },
    {
      id_registro: 42633,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-13",
    },
    {
      id_registro: 42639,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-10-14",
    },
    {
      id_registro: 45359,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-12-15",
    },
    {
      id_registro: 32698,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 33417,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 35219,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 36403,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-08",
    },
    {
      id_registro: 34922,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 31359,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31360,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-19",
    },
    {
      id_registro: 31467,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-03-24",
    },
    {
      id_registro: 32405,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 37525,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37526,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37530,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37532,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37535,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37537,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37538,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37542,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37544,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-27",
    },
    {
      id_registro: 37615,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37617,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37619,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37620,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37622,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 37626,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 34804,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34980,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35540,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 36654,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-11",
    },
    {
      id_registro: 33652,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 34074,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-12",
    },
    {
      id_registro: 35429,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 37088,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-20",
    },
    {
      id_registro: 38700,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-22",
    },
    {
      id_registro: 33035,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 34537,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 35552,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 31831,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-07",
    },
    {
      id_registro: 32355,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-16",
    },
    {
      id_registro: 32721,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-22",
    },
    {
      id_registro: 33568,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33744,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 34135,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34376,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34862,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 41851,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-30",
    },
    {
      id_registro: 41911,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-09-26",
    },
    {
      id_registro: 32916,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 32920,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33328,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-04-30",
    },
    {
      id_registro: 33474,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33480,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33482,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33485,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33491,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33494,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33498,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 33502,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33509,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33514,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33731,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33733,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-06",
    },
    {
      id_registro: 33736,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-03",
    },
    {
      id_registro: 33887,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 33903,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-09",
    },
    {
      id_registro: 34038,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34068,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34072,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34077,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34083,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-14",
    },
    {
      id_registro: 34095,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34228,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34330,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34334,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34342,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-13",
    },
    {
      id_registro: 34409,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34560,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34567,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-05",
    },
    {
      id_registro: 34576,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34580,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34583,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34597,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34599,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34603,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34606,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34607,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34608,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34609,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34610,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-16",
    },
    {
      id_registro: 34611,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34632,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-17",
    },
    {
      id_registro: 34634,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34638,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34651,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34656,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 34661,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 34783,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-21",
    },
    {
      id_registro: 34788,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-20",
    },
    {
      id_registro: 35142,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35149,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-24",
    },
    {
      id_registro: 35151,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35155,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-23",
    },
    {
      id_registro: 35267,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 35288,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35335,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35354,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35358,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-28",
    },
    {
      id_registro: 35360,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-27",
    },
    {
      id_registro: 35362,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35533,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 35557,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35572,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35579,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35592,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-05-30",
    },
    {
      id_registro: 35806,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-04",
    },
    {
      id_registro: 35995,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36055,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36056,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-05",
    },
    {
      id_registro: 36058,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-02",
    },
    {
      id_registro: 36117,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-06",
    },
    {
      id_registro: 36150,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36173,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36248,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36251,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-10",
    },
    {
      id_registro: 36252,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36257,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-09",
    },
    {
      id_registro: 36544,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 36548,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 36664,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 36678,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36723,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 36745,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-01",
    },
    {
      id_registro: 36775,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 36777,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-17",
    },
    {
      id_registro: 37017,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-23",
    },
    {
      id_registro: 37187,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-24",
    },
    {
      id_registro: 37363,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37364,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-06-30",
    },
    {
      id_registro: 37826,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2025-07-04",
    },
    {
      id_registro: 46800,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-05",
    },
    {
      id_registro: 46801,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-05",
    },
    {
      id_registro: 46802,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-05",
    },
    {
      id_registro: 46809,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46810,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46812,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46813,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46819,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46820,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-05",
    },
    {
      id_registro: 46827,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46828,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46829,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46830,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46831,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46832,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46833,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46835,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-06",
    },
    {
      id_registro: 46836,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46837,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-06",
    },
    {
      id_registro: 46839,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46840,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46842,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46843,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46844,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-06",
    },
    {
      id_registro: 46846,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46848,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46850,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46852,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46853,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46857,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46858,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46859,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46860,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 46861,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46862,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46863,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46869,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46870,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46872,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46873,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46874,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46875,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46878,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46881,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46888,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46891,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46892,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46894,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46896,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-06",
    },
    {
      id_registro: 46898,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46899,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46900,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46902,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46904,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 46905,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46907,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46911,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46914,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-06",
    },
    {
      id_registro: 46916,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46919,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46920,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 46924,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46926,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46927,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46929,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46930,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46931,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46932,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46933,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 46934,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 46935,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46938,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 46939,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 46940,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46941,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46943,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 46945,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 46948,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46950,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46951,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46954,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46956,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46957,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46963,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46964,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 46966,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 46968,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 46970,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 46975,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 46980,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46982,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46985,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46992,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 46997,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 46998,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 47010,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47011,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47013,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 47017,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47018,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47019,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47020,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47021,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47022,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47023,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47025,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47028,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47029,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47030,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47031,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47032,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47036,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47037,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47039,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47040,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47041,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 47042,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47047,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47049,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47050,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47051,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47052,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47053,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47056,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47057,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47058,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47063,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47065,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 47067,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 47074,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47075,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47077,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47079,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47080,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47085,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 47086,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47088,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 47090,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47092,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47095,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47096,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47097,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47099,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47101,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47102,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2026-01-07",
    },
    {
      id_registro: 47104,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47108,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47110,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47111,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47112,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47113,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47118,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47119,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47120,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47125,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47126,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47127,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47128,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47134,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47135,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 47137,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47138,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47139,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47140,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47142,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47143,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 47148,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47154,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47155,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47156,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47157,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47159,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47160,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47161,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47165,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47166,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47167,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47168,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47169,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47170,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47171,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47173,
      entidad_nombre_res: "HIDALGO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47174,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47175,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47177,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47178,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47180,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47181,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47182,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47184,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47186,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47187,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47188,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47189,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47192,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47194,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47195,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-08",
    },
    {
      id_registro: 47196,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47197,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47198,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47201,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47204,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47205,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47206,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47207,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47210,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47212,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47213,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47214,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47215,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47216,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47217,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47218,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47221,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47222,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47223,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47224,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47225,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47226,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47227,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47228,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47231,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47232,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47233,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47234,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47235,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47241,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47242,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47243,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47244,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47245,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47246,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47248,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47249,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47251,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47253,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47254,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47255,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47256,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47259,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47260,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47261,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47262,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47264,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47265,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47267,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47269,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47273,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47275,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47276,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47277,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47278,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47279,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47280,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47281,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47282,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47283,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-09",
    },
    {
      id_registro: 47286,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47288,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47289,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47293,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47294,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47296,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47297,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47298,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47299,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47300,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47301,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47302,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47306,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47311,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47312,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47313,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47315,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47317,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47318,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47321,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47322,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47324,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47325,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47326,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47327,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47329,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47330,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47331,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47333,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47334,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47335,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47336,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47338,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47342,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47343,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47344,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47345,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47346,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47347,
      entidad_nombre_res: "SAN LUIS POTOSÍ",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47348,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47350,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47351,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47353,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47354,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47355,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47365,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47367,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47373,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47376,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47377,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47379,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47381,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47383,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47384,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47385,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47386,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47387,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47389,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47394,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47395,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-10",
    },
    {
      id_registro: 47396,
      entidad_nombre_res: "SAN LUIS POTOSÍ",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47397,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47398,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47399,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47400,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47401,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47403,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47404,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47406,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47411,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47412,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47413,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47414,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47416,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47417,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47419,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47420,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47421,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47424,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47425,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47426,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47429,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47430,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47433,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47435,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47436,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47437,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47439,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-11",
    },
    {
      id_registro: 47440,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47441,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47442,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47443,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47444,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47445,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47446,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47448,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47449,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47451,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47453,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47455,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47457,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47458,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47459,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47462,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47463,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47464,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47466,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47467,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47469,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47471,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47474,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47478,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47481,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47482,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47483,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47484,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47485,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47486,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47488,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47489,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47490,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47491,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47492,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47493,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47494,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47495,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47497,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47499,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-12",
    },
    {
      id_registro: 47500,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47502,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47503,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47506,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47508,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47510,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47511,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47512,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47513,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47514,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47515,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47516,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47517,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47518,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47519,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47520,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47521,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47522,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47525,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47526,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47528,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47529,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47530,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47531,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47533,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47534,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47537,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47538,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47541,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47542,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47544,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47546,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47547,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47548,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47549,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47550,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47551,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47552,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47554,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47556,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47559,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47560,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47561,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47563,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47565,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47566,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47568,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47569,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47572,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-18",
    },
    {
      id_registro: 47574,
      entidad_nombre_res: "SAN LUIS POTOSÍ",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47576,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47579,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47580,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47581,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47582,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47585,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47586,
      entidad_nombre_res: "AGUASCALIENTES",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47587,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47588,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47589,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47590,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47591,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47592,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47593,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47598,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47599,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47600,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47601,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47605,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47606,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47608,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47612,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47613,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47615,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-18",
    },
    {
      id_registro: 47617,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47618,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47621,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47625,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-13",
    },
    {
      id_registro: 47626,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47627,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47629,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47630,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47631,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47633,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47634,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47635,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47636,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47638,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47640,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47641,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47642,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47644,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47646,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47647,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47648,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47651,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47652,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47655,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47657,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47658,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47659,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47662,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47663,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47664,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47669,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47672,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47674,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47676,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47677,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47678,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47679,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47680,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47681,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47683,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47692,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47696,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47699,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47703,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47704,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47706,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47707,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47710,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47711,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47712,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47713,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47715,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47717,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47718,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47720,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47723,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47724,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47726,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-18",
    },
    {
      id_registro: 47727,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47729,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47730,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47733,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47734,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47736,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47739,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47740,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47741,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47742,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47743,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47746,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47747,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-14",
    },
    {
      id_registro: 47750,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47752,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47753,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47756,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47757,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47758,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47759,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47760,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47764,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47770,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47771,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47772,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47773,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47774,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47775,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47776,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47777,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47780,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47782,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47785,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47786,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47788,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47789,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47793,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47794,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47795,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47796,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47797,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47798,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47799,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47805,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47807,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47808,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47812,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47813,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47814,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47815,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47816,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47823,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47826,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47831,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47832,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47834,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47835,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47843,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47845,
      entidad_nombre_res: "HIDALGO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47850,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47852,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47854,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47855,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47856,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47857,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47864,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47865,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47870,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47874,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47875,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2026-01-05",
    },
    {
      id_registro: 47876,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47878,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47879,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47880,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47881,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47882,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47883,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47884,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47886,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47892,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47894,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47897,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47898,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47902,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47903,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47905,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47907,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47909,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47911,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47913,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47916,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47917,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47918,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47919,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47922,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47923,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47924,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47925,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47930,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47931,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47934,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47935,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47936,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47937,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47938,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47940,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47941,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47942,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-18",
    },
    {
      id_registro: 47944,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47946,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47948,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47949,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47950,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47955,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47958,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47959,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47961,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47963,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47964,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47965,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47966,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47968,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47970,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47975,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47976,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47979,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47981,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47983,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47984,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47989,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47990,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47991,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 47993,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47995,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47997,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47999,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48001,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48006,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48014,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48018,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48021,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48041,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48044,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-18",
    },
    {
      id_registro: 48050,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48053,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48055,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48056,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-18",
    },
    {
      id_registro: 48060,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48064,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48066,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48070,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48071,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48079,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-18",
    },
    {
      id_registro: 48081,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48085,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 48087,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48088,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48089,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48090,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48091,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48092,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48093,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48094,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48096,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48097,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48107,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48108,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48110,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48114,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48115,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48116,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48121,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48122,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48127,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48129,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48131,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48133,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48134,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48140,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48143,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48146,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48148,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48149,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48152,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48153,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48154,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48155,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48157,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48158,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48159,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48165,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48170,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48172,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48179,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48195,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48200,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48202,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48204,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48215,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48217,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48223,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48224,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48225,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48227,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48235,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48238,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48239,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48240,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48243,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48244,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48247,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48248,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48249,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48250,
      entidad_nombre_res: "HIDALGO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48267,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48276,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48283,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48285,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48286,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48287,
      entidad_nombre_res: "HIDALGO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48288,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48290,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-17",
    },
    {
      id_registro: 48341,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47323,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47507,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 47509,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 47584,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-15",
    },
    {
      id_registro: 47619,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-01-16",
    },
    {
      id_registro: 47620,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 47825,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 47895,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 47952,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48013,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 48015,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48016,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48020,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48022,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48023,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48024,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48026,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48030,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48033,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48037,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48040,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48042,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48061,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48063,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48078,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48083,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48102,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48105,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48109,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48119,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48135,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48137,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48138,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48142,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48171,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48176,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48178,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48182,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48184,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48188,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48197,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48208,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 48209,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48212,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48228,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 48231,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48233,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48237,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48252,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48262,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48264,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48281,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48292,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48294,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48295,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48296,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48297,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48300,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48302,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48309,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48311,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48313,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48314,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48315,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48316,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48317,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 48318,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48319,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48322,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48323,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48327,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 48328,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48330,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48334,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48335,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48343,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48344,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 48347,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48348,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48349,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48350,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48351,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48352,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48353,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48354,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48355,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48356,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48357,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48358,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 48363,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48365,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 48367,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48368,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48369,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48370,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 48371,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48372,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 48373,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 48374,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 48376,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48377,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48378,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48380,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48388,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48389,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 48390,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48394,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48396,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 48397,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48398,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48399,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48401,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48402,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 48405,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48411,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48413,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48414,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48417,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48418,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 48419,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48423,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48426,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48427,
      entidad_nombre_res: "AGUASCALIENTES",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48430,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48431,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48432,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48434,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48437,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48440,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48442,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48445,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48449,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48451,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48452,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48454,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48456,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48458,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48462,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48464,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48466,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48467,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48468,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48471,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 48472,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48474,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48477,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48482,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48484,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 48486,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48487,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48488,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48490,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48491,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48492,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48493,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48497,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48498,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48499,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48500,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-19",
    },
    {
      id_registro: 48501,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48502,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48503,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48505,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48508,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48511,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48512,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48518,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48520,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48521,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48522,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48524,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48526,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48527,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48529,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48531,
      entidad_nombre_res: "HIDALGO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48536,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48539,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48540,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 48541,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48542,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48546,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48547,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48549,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 48550,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48563,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48565,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48567,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48568,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48570,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48571,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48573,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48575,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48576,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48577,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48578,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 48579,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48580,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48581,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48583,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48584,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48585,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48587,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48588,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48589,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48591,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48598,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48599,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 48600,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48601,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48604,
      entidad_nombre_res: "YUCATÁN",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 48605,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48607,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48611,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48612,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48613,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48619,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48625,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48626,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48628,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48632,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48633,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48634,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48637,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48638,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48640,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48641,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48642,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48643,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48647,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48649,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48653,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48654,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48655,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48656,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48658,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48659,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48661,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48663,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48665,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48667,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48672,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48674,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48680,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48688,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48691,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48692,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48693,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48696,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48699,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48701,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48704,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48705,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-20",
    },
    {
      id_registro: 48706,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48708,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48709,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48713,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48714,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48715,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48716,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48719,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 48723,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48727,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 48734,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48738,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48739,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48741,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48742,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48744,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48745,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48747,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48749,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48750,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48751,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48753,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48754,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48756,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48757,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48758,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 48759,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48762,
      entidad_nombre_res: "HIDALGO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48767,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48769,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48773,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48774,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48777,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48778,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48781,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 48784,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-21",
    },
    {
      id_registro: 48787,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48789,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48796,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48797,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48798,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48800,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48802,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48806,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48812,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48813,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48814,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48815,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48816,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48818,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48819,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48820,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48821,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48822,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48823,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48824,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48827,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48828,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48831,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48836,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48840,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48841,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48842,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48844,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48847,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48848,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48861,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48870,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48873,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48878,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48879,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48881,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48886,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48889,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48890,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48891,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48892,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48893,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48897,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48901,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48906,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48907,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48911,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48916,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48917,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48920,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48924,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 48930,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48931,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48933,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48934,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48940,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 48941,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48942,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48944,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48948,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48950,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48953,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48955,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48958,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48959,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48960,
      entidad_nombre_res: "AGUASCALIENTES",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48961,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48962,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48964,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 48968,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48972,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48974,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48976,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48977,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48982,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48984,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 48985,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 48991,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 48995,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 48999,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49002,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49003,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 49006,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-22",
    },
    {
      id_registro: 49012,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49025,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49030,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49031,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49032,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49034,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49036,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 49041,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49043,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49044,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49049,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49052,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49053,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49056,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49063,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49071,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49074,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 49075,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49076,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49078,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49079,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49080,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49083,
      entidad_nombre_res: "AGUASCALIENTES",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49084,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49090,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49092,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49098,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49100,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49101,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49108,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49109,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49114,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49116,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49121,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49122,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49123,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49124,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49125,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49126,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49128,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49129,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49131,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49132,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49134,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49140,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49141,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49143,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49146,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49152,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49157,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49160,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49164,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49165,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49166,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49168,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49170,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49173,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 49176,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49179,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49196,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49200,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49201,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49205,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49210,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49216,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49217,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49222,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49226,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49229,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49233,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-23",
    },
    {
      id_registro: 49235,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49240,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49242,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49250,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49251,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49252,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49253,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49254,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49256,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49257,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49259,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49261,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49265,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49267,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49273,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49280,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49287,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49288,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49295,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49296,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49297,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49300,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49303,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49308,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49310,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49312,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49316,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49321,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49327,
      entidad_nombre_res: "AGUASCALIENTES",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49328,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49334,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49337,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49339,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 49349,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49352,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49353,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49357,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49359,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49362,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49364,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49365,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49370,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49373,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49374,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49375,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49379,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49383,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49386,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49388,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49389,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49390,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 49391,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49394,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49395,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49398,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49399,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49400,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49404,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49406,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49417,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49421,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49422,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 49424,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49425,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49429,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49430,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49431,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49432,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49434,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49435,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49437,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49438,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49440,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49442,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49443,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49446,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49450,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49451,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49454,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49455,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49456,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49457,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49459,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49460,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-24",
    },
    {
      id_registro: 49461,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49463,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49464,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49465,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49466,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49468,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49469,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49470,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49474,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49475,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49476,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 49481,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49485,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 49507,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49509,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49516,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49517,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49521,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49523,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49527,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-25",
    },
    {
      id_registro: 49528,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49529,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49534,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 49539,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49540,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49541,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49544,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49545,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49553,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49554,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49564,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49565,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49566,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49570,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49573,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49575,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49576,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49577,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49578,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49579,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49582,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49584,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49586,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49588,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49589,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49591,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49600,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49602,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49605,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49607,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49609,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49610,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49611,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49612,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49613,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49614,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49615,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49620,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49621,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49623,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49626,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49627,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49631,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49634,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49637,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49639,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49641,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49645,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49646,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49647,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49653,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49655,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49657,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49659,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49660,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49661,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49662,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49664,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49665,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49667,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49672,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 49675,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49677,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49678,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49688,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49689,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49694,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49695,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49699,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49702,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49705,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49710,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49711,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49722,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49724,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49725,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49727,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49731,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49733,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49736,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49740,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49741,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49742,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49744,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49745,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49747,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49753,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49756,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49759,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49760,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49761,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49762,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49765,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49767,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49770,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49774,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49775,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49776,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49777,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49778,
      entidad_nombre_res: "QUINTANA ROO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49781,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49785,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49789,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49790,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49792,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49794,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49798,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49799,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 49801,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-26",
    },
    {
      id_registro: 49802,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49805,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49815,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49821,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49823,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49827,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49828,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49831,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49836,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49841,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49845,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49846,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49848,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49855,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49858,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49859,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49861,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49863,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49865,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49870,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49872,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49873,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49878,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49879,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49882,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49887,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49894,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49896,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49904,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49908,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49910,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49912,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49914,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49917,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49918,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49921,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49924,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49927,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49937,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49938,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49941,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49943,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49953,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49954,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49968,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49973,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49974,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49975,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49976,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49977,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49980,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49983,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49985,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 49986,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49987,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49990,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49991,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49993,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49994,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49995,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 49996,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 49997,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 49998,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 49999,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50000,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50001,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50003,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50004,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50005,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50007,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50008,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50010,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50011,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50015,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50016,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50018,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50020,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50026,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50028,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50030,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50034,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50036,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50039,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50040,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50042,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50047,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50049,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50050,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50053,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50055,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50056,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50059,
      entidad_nombre_res: "AGUASCALIENTES",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50060,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50062,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50063,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50064,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50065,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50066,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50070,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50074,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50075,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50076,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50080,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50082,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 50093,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50094,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50096,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50097,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50099,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50103,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50104,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50105,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50109,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50110,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50115,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50116,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50120,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50122,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50123,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50125,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50126,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50128,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50133,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2026-01-27",
    },
    {
      id_registro: 50135,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50138,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50142,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50143,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50148,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50155,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50162,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50163,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50167,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50168,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50172,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50175,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50177,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50179,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50190,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50192,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50196,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50198,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50199,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50201,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50206,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50207,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50210,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50213,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50214,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50215,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50216,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50219,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50220,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50229,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50230,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50233,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50240,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50249,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50252,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50256,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50260,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50262,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50263,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50265,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50267,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50269,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50276,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50277,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50280,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50281,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50282,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50285,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50289,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50301,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50307,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50308,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50309,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50311,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50314,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50318,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50319,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50321,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50323,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50324,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50325,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50327,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50328,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50330,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50337,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50340,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50342,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50344,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50352,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50353,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50358,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50361,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50366,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50369,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50374,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50375,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50376,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50382,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50383,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50385,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50387,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50388,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50390,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50392,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50398,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50399,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50404,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50406,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50407,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50408,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50411,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50413,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50414,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50417,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50418,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50420,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50425,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50429,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50431,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50435,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50437,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50438,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50440,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50443,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50447,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50450,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50455,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50460,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50465,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50466,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50467,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50471,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50472,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50474,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50475,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50476,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50477,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50481,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50482,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50491,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50493,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50496,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50499,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50500,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50501,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50502,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50506,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50508,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50516,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50521,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50522,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50523,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50526,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50527,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50528,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50529,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50533,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50535,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50538,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50542,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50546,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50548,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 50549,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50552,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50554,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50555,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50557,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50559,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-28",
    },
    {
      id_registro: 50563,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50571,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50572,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50576,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50579,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50580,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50585,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50589,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50591,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50595,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50598,
      entidad_nombre_res: "YUCATÁN",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50599,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50603,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50604,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50605,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50606,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50607,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50611,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50614,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50615,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50618,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50619,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50620,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50621,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50622,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50625,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50627,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50628,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50630,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50632,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50633,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50634,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50635,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50637,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50638,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50641,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50642,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50643,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50644,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 50645,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50646,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50647,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50648,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50650,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50652,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50653,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50654,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50655,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50662,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50665,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50667,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50668,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50670,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50676,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50677,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50679,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50681,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50685,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50686,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50687,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50689,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50693,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50694,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50698,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50700,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50702,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-29",
    },
    {
      id_registro: 50705,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50708,
      entidad_nombre_res: "QUINTANA ROO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50709,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50713,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50714,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50717,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50725,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50726,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50728,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50729,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50732,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50734,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50737,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50738,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50741,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50744,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50749,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50750,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50752,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50753,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50754,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50755,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50756,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50762,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50765,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50767,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50768,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50772,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50773,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50776,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50778,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 50779,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50783,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50784,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50788,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50790,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50793,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50797,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50798,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50799,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50801,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50802,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50804,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50806,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50807,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50808,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50810,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50811,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50813,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50814,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50817,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50818,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50820,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50822,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50825,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50829,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50830,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 50831,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50834,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50838,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50839,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50840,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50841,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50843,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50844,
      entidad_nombre_res: "GUANAJUATO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50846,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50847,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50849,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50850,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50853,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50854,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50855,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50856,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50859,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50862,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50865,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50866,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50874,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50876,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-10",
    },
    {
      id_registro: 50877,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50878,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50879,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50880,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50881,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50883,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50885,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50888,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 50891,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50900,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50904,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50906,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50908,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50912,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 50917,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50918,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 50919,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 50924,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50927,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50928,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50930,
      entidad_nombre_res: "QUINTANA ROO",
      fecha_diagnostico: "2026-01-30",
    },
    {
      id_registro: 50935,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50938,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 50943,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50952,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50953,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50955,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50958,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50960,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50962,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50963,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50964,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50965,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50966,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 50967,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50969,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50972,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50974,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50975,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50976,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50977,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50981,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 50986,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50987,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50989,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 50991,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50992,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 50994,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 50998,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51000,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51002,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51004,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51006,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51008,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51009,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51010,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51011,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51012,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51014,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51015,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51017,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51019,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51024,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51029,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51031,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51034,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51036,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51038,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51042,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51044,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51049,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51052,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51053,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51054,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51057,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51059,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51061,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51067,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51075,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51077,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51078,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51079,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51085,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51090,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51092,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51102,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51109,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51116,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51119,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51125,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51127,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51129,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51130,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51134,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51137,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51141,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51149,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51151,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51153,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51155,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51157,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51165,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51167,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51169,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51171,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51177,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51180,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51181,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51182,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51184,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51187,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51190,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51191,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51194,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51195,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 51197,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51201,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51203,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51204,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51206,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51207,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51209,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51211,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51215,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51221,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51222,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51223,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51224,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51226,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51227,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51229,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-01-31",
    },
    {
      id_registro: 51230,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51231,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51232,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51233,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51234,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51235,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51237,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51238,
      entidad_nombre_res: "BAJA CALIFORNIA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51240,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51245,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51247,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51249,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51251,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51252,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51254,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51255,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51257,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51258,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51261,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51262,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51263,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51265,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51271,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51276,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51284,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51296,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51299,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51301,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51303,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51309,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51310,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51311,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51312,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51313,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51314,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51315,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51318,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51322,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51325,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51329,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51334,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51336,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51338,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51341,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51342,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51346,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51347,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51348,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51349,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51350,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51351,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51354,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51355,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51360,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51361,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51362,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-01",
    },
    {
      id_registro: 51368,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51369,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51371,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51374,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51376,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51379,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51381,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51382,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51384,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51390,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51391,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51396,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51397,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51398,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51400,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51405,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51407,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51411,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51414,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51421,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51423,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51431,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51432,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51434,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51437,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51438,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51443,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51444,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51445,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51446,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51447,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51450,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51454,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51455,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51456,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51460,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51461,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51463,
      entidad_nombre_res: "OAXACA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51464,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51466,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51467,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51470,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51471,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51474,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51475,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51476,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51477,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51478,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51481,
      entidad_nombre_res: "QUINTANA ROO",
      fecha_diagnostico: "2026-02-02",
    },
    {
      id_registro: 51482,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51483,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51484,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51485,
      entidad_nombre_res: "QUINTANA ROO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51489,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51490,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51496,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51498,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51502,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51503,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51505,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51507,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51508,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51509,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51510,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51513,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51514,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51515,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51517,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51519,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51524,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51528,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51530,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51531,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51535,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51538,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 51541,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51542,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51544,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51546,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51547,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51553,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51556,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51559,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51564,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51567,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51568,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51569,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51572,
      entidad_nombre_res: "QUINTANA ROO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51575,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51582,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51584,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51585,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51586,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51589,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51593,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51596,
      entidad_nombre_res: "QUINTANA ROO",
      fecha_diagnostico: "2026-02-03",
    },
    {
      id_registro: 51599,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51602,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51603,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51604,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51610,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51613,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51614,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51618,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51621,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51625,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51628,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51635,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51637,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51639,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51642,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51647,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51650,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51654,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51657,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51660,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51666,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51667,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51669,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51670,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51674,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51675,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51680,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51681,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51682,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51686,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51688,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51694,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51697,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51699,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51700,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51701,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51709,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51711,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51712,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51714,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51716,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51717,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51718,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51720,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51721,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51740,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51749,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51757,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51761,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51765,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51780,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51781,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51782,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 51786,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51791,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51793,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51801,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51803,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51805,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51809,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51811,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51819,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 51821,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51825,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51833,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-10",
    },
    {
      id_registro: 51835,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51842,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51861,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51865,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51871,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51872,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51876,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51882,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51883,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51884,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51888,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51891,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 51894,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51898,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51899,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51905,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51908,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51910,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51911,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51919,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51926,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51950,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 51968,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51975,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51976,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51979,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51986,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51989,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51990,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51993,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51994,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 51997,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 51998,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 52002,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 52003,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52004,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 52007,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52015,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52018,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52019,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52020,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52034,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52036,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52040,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52041,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52043,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52044,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2026-02-04",
    },
    {
      id_registro: 52048,
      entidad_nombre_res: "CHIHUAHUA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52054,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52056,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52057,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52062,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52063,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 52066,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52073,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52074,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52075,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52077,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52086,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52090,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52099,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52102,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52105,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52108,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52110,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52117,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52119,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52129,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52135,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52139,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52145,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52156,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52159,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52164,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52176,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52178,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52184,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52189,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52193,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52196,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52201,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52202,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52203,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52208,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52211,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52213,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52216,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52232,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52241,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52244,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52247,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52249,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52251,
      entidad_nombre_res: "PUEBLA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52259,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52263,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52266,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52275,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52278,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52282,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52284,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52287,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52294,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52295,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52298,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52300,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52301,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52306,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52311,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52315,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-10",
    },
    {
      id_registro: 52318,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52322,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52325,
      entidad_nombre_res: "YUCATÁN",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 52329,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52330,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52336,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52339,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52342,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52346,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52348,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52352,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52354,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52358,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52360,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52368,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52370,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52371,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52374,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52377,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52378,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52382,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52386,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52389,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52390,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52391,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52393,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52394,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52402,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52411,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52412,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52414,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52415,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52419,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52422,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52426,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52428,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52432,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52441,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52456,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52461,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52463,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52465,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52471,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52472,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52474,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52483,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52502,
      entidad_nombre_res: "QUINTANA ROO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52503,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52507,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52515,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52520,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52531,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52534,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52541,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52548,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52555,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-10",
    },
    {
      id_registro: 52574,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52586,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52600,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52605,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52608,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52610,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-05",
    },
    {
      id_registro: 52619,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52621,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52624,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52625,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52626,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52638,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52652,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52663,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52671,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52675,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52682,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52684,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52686,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52687,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52691,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52696,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52697,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52700,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52701,
      entidad_nombre_res: "QUERÉTARO",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52704,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52705,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52707,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52712,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52715,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52716,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52718,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 52721,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52723,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52725,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 52730,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 52735,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52736,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 52739,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52740,
      entidad_nombre_res: "SONORA",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52747,
      entidad_nombre_res: "VERACRUZ",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52749,
      entidad_nombre_res: "NUEVO LEÓN",
      fecha_diagnostico: "2026-02-06",
    },
    {
      id_registro: 52752,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52760,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52763,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52770,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52771,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52772,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52778,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52779,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52782,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52797,
      entidad_nombre_res: "TABASCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52798,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52799,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52800,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52803,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52804,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52808,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52811,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52816,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52817,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-10",
    },
    {
      id_registro: 52826,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52830,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52833,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52837,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 52838,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52841,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 52849,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52852,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 52863,
      entidad_nombre_res: "GUERRERO",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 52865,
      entidad_nombre_res: "NAYARIT",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52928,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-10",
    },
    {
      id_registro: 52955,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52967,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52970,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52976,
      entidad_nombre_res: "MÉXICO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52977,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52981,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52994,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 52997,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 52998,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53008,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53009,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53012,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53013,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53018,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53019,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53024,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53029,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53032,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53033,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53040,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53042,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53044,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53048,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53049,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53055,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53066,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53075,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53084,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53087,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53088,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53093,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53094,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53096,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53097,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53099,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-10",
    },
    {
      id_registro: 53100,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53107,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53114,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53123,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53133,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53138,
      entidad_nombre_res: "DURANGO",
      fecha_diagnostico: "2026-02-09",
    },
    {
      id_registro: 53139,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53141,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53144,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53145,
      entidad_nombre_res: "CHIAPAS",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53146,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53150,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53152,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 53154,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53157,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53161,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53164,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 53166,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53172,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53177,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53178,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-10",
    },
    {
      id_registro: 53184,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53211,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53214,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53216,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53218,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53224,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53226,
      entidad_nombre_res: "SINALOA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53227,
      entidad_nombre_res: "MORELOS",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53260,
      entidad_nombre_res: "COLIMA",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 53261,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 53262,
      entidad_nombre_res: "MICHOACÁN",
      fecha_diagnostico: "2026-02-08",
    },
    {
      id_registro: 53279,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53280,
      entidad_nombre_res: "TLAXCALA",
      fecha_diagnostico: "2026-02-07",
    },
    {
      id_registro: 53291,
      entidad_nombre_res: "JALISCO",
      fecha_diagnostico: "2026-02-10",
    },
    {
      id_registro: 53315,
      entidad_nombre_res: "CIUDAD DE MÉXICO",
      fecha_diagnostico: "2026-02-08",
    },
  ];
})();
